
module MapDrawing {
    export class SelectTool extends BaseToolIcon {
        iconX = 0;
        iconY = 0;

        onSelect(mapDrawer: MapDrawer, prevTool: BaseToolIcon, subMenu: string) {

        }

        onMouseUp(ev: google.maps.MouseEvent, mapDrawer: MapDrawer) {
            if (!this.isDragging && !mapDrawer.shiftDown && !mapDrawer.ctrlDown) {
                mapDrawer.clearSelection();
            }
        }
    }
    
    class LabeledScreenPoints {
        ScreenPoints : google.maps.Point[] = [];
        Labels : number[] = [];
    }

    class SegmentState {
        PositivePoints : google.maps.Point[] = [];
        NegativePoints : google.maps.Point[] = [];

        DisplayPositivePoints : google.maps.Circle[] = [];
        DisplayNegativePoints : google.maps.Circle[] = [];

        Predictions : google.maps.Polygon[] = [];
        EmbeddingKey : string = null;

        public ClearPredictions() {
            for (let i = 0; i < this.DisplayPositivePoints.length; i++) {
                let circle : google.maps.Circle = this.DisplayPositivePoints[i];
                circle.setMap(null);
            }

            for (let i = 0; i < this.DisplayNegativePoints.length; i++) {
                let circle : google.maps.Circle = this.DisplayNegativePoints[i];
                circle.setMap(null);
            }

            for (let i = 0; i < this.Predictions.length; i++) {
                let poly : google.maps.Polygon = this.Predictions[i];
                poly.setMap(null);
            }

            this.PositivePoints = [];
            this.NegativePoints = [];
            this.DisplayPositivePoints = [];
            this.DisplayNegativePoints = [];
            this.Predictions = [];
        }
        
        public Clear() {
            this.ClearPredictions();
            this.EmbeddingKey = null;
        }
        
        public GetLabeledScreenPoints() : LabeledScreenPoints {
            let screenPoints : google.maps.Point[] = [];

            screenPoints.push(...this.PositivePoints);
            screenPoints.push(...this.NegativePoints);

            let labels : number[] = [];
            labels.length = screenPoints.length;
            labels.fill(1, 0, this.PositivePoints.length);
            labels.fill(0, this.PositivePoints.length);

            return {
                ScreenPoints : screenPoints,
                Labels : labels
            };
        }
    }

    export class HandTool extends BaseToolIcon {
        iconX = 7;
        iconY = 0;

        onSelect(mapDrawer: MapDrawer, prevTool: BaseToolIcon, subMenu: string) {

        }
    }

    interface DrawingContext {
        mapDrawer: MapDrawer;
        tool: DrawTool;   
    }
    
    interface ClickEvent {
        latLng: google.maps.LatLng;
    }
    
    interface IShapeTool {
        handleClick(ev: { latLng: google.maps.LatLng}, ctx: DrawingContext): void;
        handleClose(ctx: DrawingContext): void;
        draw(ctx: DrawingContext, path: google.maps.MVCArray<google.maps.LatLng>, latLng: LatLng, mapDrawer: MapDrawer): void;
    }
    
    class RectangleTool implements IShapeTool {
        handleClick(ev: ClickEvent, context: DrawingContext) {
            const { mapDrawer, tool } = context;
            const polyline = tool.polyline;
            if (!polyline || !ev.latLng) return;

            const path = polyline.getPath();
            const evLatLng = tool.getNextLatLng(null, null, LatLng.FromGMLatLng(ev.latLng), mapDrawer);
            switch (tool.step) {
                case 0:
                {
                    const gmEvLatLng = evLatLng.ToGMLatLng();
                    path.push(gmEvLatLng);
                    path.push(gmEvLatLng);
                    path.push(gmEvLatLng);
                    path.push(gmEvLatLng);
                    tool.step = 1;
                    break;
                }
                case 1:
                {
                    this.draw(context, path, evLatLng);
                    const w = LatLng.FromGMLatLng(path.getAt(0)).DistanceTo(LatLng.FromGMLatLng(path.getAt(1)));
                    const h = LatLng.FromGMLatLng(path.getAt(1)).DistanceTo(LatLng.FromGMLatLng(path.getAt(2)));
                    if (w <= 0 || h <= 0)
                        tool.polyline = null;
                    tool.onPolylineClosed(mapDrawer);
                    break;
                }
            }
        }
        handleClose(ctx: DrawingContext) {
            
        }
        //--------------------
        // Rectangle Draw Tool 
        //--------------------
        // Draws a rectangle from the LatLng provided via the cursor drag or the preset edgelength.
        draw(ctx: DrawingContext, path: google.maps.MVCArray<google.maps.LatLng>, latlng: LatLng) {
            const { tool, mapDrawer } = ctx;
            const helperLines = mapDrawer.viewModel.helperLines;

            if (!latlng)
                latlng = LatLng.FromGMLatLng(path.getAt(2));

            const ll0 = LatLng.FromGMLatLng(path.getAt(0)),
                p0 = ll0.ToPoint2D(),
                p2 = latlng.ToPoint2D(),
                pDelta = p2.sub(p0);

            let dx = Point2D.XAxis;
            let dy = Point2D.YAxis;

            if (helperLines.length && mapDrawer.shiftDown) {
                const helperLine = helperLines[0];
                dx = helperLine.dirs[0];
                dy = helperLine.dirs[1];
            }

            let lx = dx.dot(pDelta);
            let ly = dy.dot(pDelta);

            let ll1 = LatLng.FromPoint2D(p0.add(dx.mul(lx)));
            let ll2 = latlng;
            let ll3 = LatLng.FromPoint2D(p0.add(dy.mul(ly)));
            const kayBoardSteps = mapDrawer.viewModel.keyBoardSteps.internalValue;
            if (mapDrawer.viewModel.cmdEdgeLength > 0 || (mapDrawer.ctrlDown && kayBoardSteps > 0)) {
                let realLenX = ll0.DistanceTo(ll1) * 1000;
                let realLenY = ll0.DistanceTo(ll3) * 1000;

                let targetLenX = realLenX;
                let targetLenY = realLenY;
                if (mapDrawer.viewModel.cmdEdgeLength > 0) {
                    targetLenX = targetLenY = mapDrawer.viewModel.cmdEdgeLength;
                } else {
                    targetLenX = Math.round(realLenX / kayBoardSteps) * kayBoardSteps;
                    targetLenY = Math.round(realLenY / kayBoardSteps) * kayBoardSteps;

                    if (targetLenX <= 0)
                        targetLenX = kayBoardSteps;
                    if (realLenX <= 0)
                        realLenX = targetLenX;

                    if (targetLenY <= 0)
                        targetLenY = kayBoardSteps;
                    if (realLenY <= 0)
                        realLenY = targetLenY;
                }

                lx *= targetLenX / realLenX;
                ly *= targetLenY / realLenY;
                ll1 = LatLng.FromPoint2D(p0.add(dx.mul(lx)));
                ll2 = LatLng.FromPoint2D(p0.add(dx.mul(lx)).add(dy.mul(ly)));
                ll3 = LatLng.FromPoint2D(p0.add(dy.mul(ly)));
            }

            path.setAt(1, ll1.ToGMLatLng());
            path.setAt(2, ll2.ToGMLatLng());
            path.setAt(3, ll3.ToGMLatLng());

            mapDrawer.setMeasureText(tool.measureTexts[0], ll0, ll1);
            mapDrawer.setMeasureText(tool.measureTexts[1], ll3, ll0);
        }
    }
    
    class CircleTool implements IShapeTool {
        handleClick(ev: ClickEvent, context: DrawingContext) {
            const { mapDrawer, tool } = context;
            const polyline = tool.polyline;
            if (!polyline || !ev.latLng) return;

            const path = polyline.getPath();
            const evLatLng = tool.getNextLatLng(null, null, LatLng.FromGMLatLng(ev.latLng), mapDrawer);

            switch (tool.step) {
                case 0:
                {
                    const gmevLatLng = evLatLng.ToGMLatLng();
                    path.push(gmevLatLng);
                    path.push(gmevLatLng);
                    tool.step = 1;
                    break;
                }
                case 1:
                {
                    if (path.getLength() <= 0)
                        tool.polyline = null;
                    else {
                        const ll0 = LatLng.FromGMLatLng(path.getAt(0));
                        this.draw(context, path, tool.getNextLatLng(null, ll0, LatLng.FromGMLatLng(ev.latLng), mapDrawer));
                        const w = ll0.DistanceTo(LatLng.FromGMLatLng(path.getAt(1)));
                        if (w <= 0)
                            tool.polyline = null;
                    }
                    tool.onPolylineClosed(mapDrawer);
                    break;
                }
            }
        }
        
        //--------------------
        // Circle Draw Tool
        //--------------------
        // Draws a circle from the LatLng radius provided via the cursor drag or the preset edgeLength.
        draw(ctx: DrawingContext, path: google.maps.MVCArray<google.maps.LatLng>, latLng: LatLng) {
            const { tool, mapDrawer} = ctx;

            if (latLng)
                path.setAt(1, latLng.ToGMLatLng());
            else
                latLng = LatLng.FromGMLatLng(path.getAt(1));

            const shiftDown = mapDrawer.shiftDown,
                ll0 = LatLng.FromGMLatLng(path.getAt(0)),
                radius = ll0.DistanceTo(latLng),
                segments = Math.round(Math.max(5, Math.min(64, (shiftDown ? radius : radius * 2) * Math.PI * 3))),
                p1 = latLng.ToPoint2D(),
                pivot = shiftDown ? ll0.ToPoint2D().add(p1).mul(0.5) : ll0.ToPoint2D(),
                count = path.getLength(),
                pi2 = LatLng.Pi2;

            for (let i = 1; i <= segments; i++) {
                const p = p1.RotateByPivot(pi2 * i / segments, pivot),
                    idx = i + 1;

                if (idx < count)
                    path.setAt(idx, LatLng.Point2DToGMLatLng(p));
                else
                    path.push(LatLng.Point2DToGMLatLng(p));
            }

            for (let j = segments + 2; count > j; j++) {
                path.removeAt(segments + 2);
            }
            mapDrawer.setMeasureText(tool.measureTexts[0], ll0, latLng);
        }
        
        handleClose(context: DrawingContext) {
            const { tool } = context;
            const polyline = tool.polyline;
            if (!polyline ) return;

            const path = polyline.getPath();
            path.removeAt(0);
            path.pop();
        }
    }
    
    class LinePolygonTool implements IShapeTool {
        handleClick(ev: ClickEvent, context: DrawingContext) {
            const { mapDrawer, tool } = context;
            const polyline = tool.polyline;
            
            const { currentLayer,  } = mapDrawer.viewModel;
            if (!polyline || !ev.latLng) return;

            const path = polyline.getPath();
            const evLatLng = tool.getNextLatLng(null, null, LatLng.FromGMLatLng(ev.latLng), mapDrawer);

            if (!path.getLength()) {
                const icon: google.maps.Symbol = {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 8,
                    strokeWeight: 4,
                    strokeOpacity: 0,
                    fillOpacity: 1,
                    fillColor: '#fff'
                };

                if (currentLayer) {
                    icon.strokeColor = currentLayer.shapeSelectedStyle.strokeColor;
                    icon.strokeOpacity = currentLayer.shapeSelectedStyle.strokeOpacity;
                }

                tool.startMarker = new google.maps.Marker({
                    map: mapDrawer.map,
                    clickable: true,
                    draggable: false,
                    position: evLatLng.ToGMLatLng(),
                    icon: icon,
                    zIndex: 10
                });

                tool.startMarker.addListener('click', tool.onPolylineClosed.bind(tool, mapDrawer));
                tool.startMarker.addListener('mouseover', tool.onstartMarkerMouseover.bind(tool, mapDrawer));
                tool.startMarker.addListener('mouseout', tool.onstartMarkerMouseout.bind(tool, mapDrawer));

                tool.snapMarker.setPosition(evLatLng.ToGMLatLng());
                path.push(evLatLng.ToGMLatLng());

                if (mapDrawer.viewModel.showCoords) {
                    const coordsText = mapDrawer.createOverlayText();
                    tool.coordsTexts.push(coordsText);
                    mapDrawer.setCoordsText(coordsText, evLatLng);
                }
                if (mapDrawer.viewModel.showCoordNumbers) {
                    const coorNumText = mapDrawer.createOverlayText();
                    mapDrawer.setCoordNumberText(coorNumText, evLatLng, path.getLength());
                    tool.coordsNumberTexts.push(coorNumText);
                }
            } else {
                if (mapDrawer.viewModel.showAngleWhileDrawing)
                    tool.angleTexts.push(mapDrawer.createOverlayText());
                if (tool.startMarker && tool.curSubmenu === 'Line') {
                    tool.startMarker.setPosition(path.getAt(path.getLength() - 1));
                    tool.onstartMarkerMouseover(mapDrawer);
                }
            }
            
            if (mapDrawer.viewModel.showLengths) {
                tool.measureTexts.push(mapDrawer.createOverlayText());
                tool.maxEdge = mapDrawer.viewModel.cmdEdgeLength;
            }
            
            path.push(ev.latLng);

            if (mapDrawer.viewModel.showCoords)
                tool.coordsTexts.push(mapDrawer.createOverlayText());
            if (mapDrawer.viewModel.showCoordNumbers) {
                const coorNumText = mapDrawer.createOverlayText();
                mapDrawer.setCoordNumberText(coorNumText, new LatLng(), path.getLength(), true);
                tool.coordsNumberTexts.push(coorNumText);
            }
        }
        
        handleClose(context: DrawingContext) {
            const { mapDrawer, tool } = context;

            const polyline = tool.polyline;
            if (!polyline ) return;
            
            const path = polyline.getPath();
            const layer = mapDrawer.viewModel.currentLayer;
            
            if(tool.curSubmenu === "Line") {
                path.pop();

                const lineWidth = Math.max(10, mapDrawer.viewModel.interferenceLineThickness.internalValue),
                    latLngs = LatLng.FromGMLatLngArray(path.getArray()),
                    latLngBounds = BoundsLatLng.FromLatLngs(latLngs),
                    origin = latLngBounds.Min,
                    pts = latLngs.map(ll => { var p = origin.DirectionTo(ll).mul(1000); return new THREE.Vector3(p.x, p.y, 0) });

                path.clear();

                const linePolys = spt.ThreeJs.utils.generateOffsetLinePolygons(pts, lineWidth).filter(ply => ply && ply.length > 2);
                if (layer.count + linePolys.length <= (layer.maxCount || 2000)) {
                    linePolys.forEach(poly => {
                        const arr = poly.map(p => origin.Offset(p.y * 0.001, p.x * 0.001).ToGMLatLng());
                        var polygon = new google.maps.Polygon({ paths: arr });
                        mapDrawer.onOverlaycomplete(polygon);
                    });
                }
            } else {
                if (mapDrawer.shiftDown) {
                    const len = path.getLength(),
                        llprev = LatLng.FromGMLatLng(path.getAt(len - 2) as google.maps.LatLng),
                        lllast = LatLng.FromGMLatLng(tool.startMarker.getPosition()),
                        evLatLng = tool.getNextLatLng(null, llprev, lllast, mapDrawer);
    
                    path.setAt(len - 2, (llprev.add(lllast.sub(evLatLng))).ToGMLatLng());
                }
    
                path.pop();
    
                if (mapDrawer.ninetyDegreeCorrection && path.getLength() >= 4) {
                    const pathLength = path.getLength();
                    // start and prev corners must be in tolerance to 90�
                    const startPoint = LatLng.FromGMLatLng(path.getAt(0)).ToPoint2D();
                    const startNextPoint = LatLng.FromGMLatLng(path.getAt(1)).ToPoint2D();
                    const endPoint = LatLng.FromGMLatLng(path.getAt(pathLength - 1)).ToPoint2D();
                    const endPrevPoint = LatLng.FromGMLatLng(path.getAt(pathLength - 2)).ToPoint2D();
    
                    const endPrevVector = endPrevPoint.sub(endPoint);
                    const endVector = startPoint.sub(endPoint);
    
                    const lengthOfProjection = endPrevVector.GetNormalized().dot(endVector);
                    const newEndPoint = endPoint.add(endPrevVector.GetNormalized().mul(lengthOfProjection));
    
                    const startVector = startNextPoint.sub(startPoint)
                    const newEndVector = newEndPoint.sub(startPoint);
                    const startCornerAngleNewEnd = Math.abs(Point2D.AngleFromVectors(newEndVector, startVector));
    
                    const endCornerAngle = Math.abs(Point2D.AngleFromVectors(endPrevVector, endVector));
                    
                    if (MapDrawing.isEqualWithTolerance(endCornerAngle, 90, 10)) {
                        if (MapDrawing.isEqualWithTolerance(startCornerAngleNewEnd, 90, 0.001)) {
                            path.pop();
                            path.push(LatLng.FromPoint2D(newEndPoint).ToGMLatLng());
                        }
                    }
                }
            }
        }
        
        // Line/Polygon Draw Tool
        //--------------------
        // Dynamically updates the last point of the line/polygon during drawing, applying snapping and refreshing all measurement and annotation overlays
        draw(context: DrawingContext, path: google.maps.MVCArray<google.maps.LatLng>, latLng: LatLng) {
            const {tool, mapDrawer} = context;
            const len = path.getLength();

            if (len) {
                let llprev = len > 1 ? LatLng.FromGMLatLng(path.getAt(len - 2) as google.maps.LatLng) : null;
                let prevPrev = len > 2 ? LatLng.FromGMLatLng(path.getAt(len - 3) as google.maps.LatLng) : null;

                let evLatLng = tool.getNextLatLng(prevPrev, llprev, latLng, mapDrawer);

                if (tool.curSubmenu !== DrawingToolEnum.Line && tool.hoverStartMarker && tool.startMarker && len > 2)
                    evLatLng = LatLng.FromGMLatLng(tool.startMarker.getPosition());

                if (tool.snapMarker)
                    tool.snapMarker.setPosition(evLatLng.ToGMLatLng());

                path.setAt(len - 1, evLatLng.ToGMLatLng());

                if (llprev && evLatLng && tool.measureTexts.length) {
                    mapDrawer.setMeasureText(tool.measureTexts[tool.measureTexts.length - 1], llprev, evLatLng);
                }
                if (len > 2 && tool.angleTexts.length)
                    mapDrawer.setAngleText(tool.angleTexts[tool.angleTexts.length - 1], LatLng.FromGMLatLng(path.getAt(len - 3) as google.maps.LatLng), llprev, evLatLng);

                if (tool.coordsTexts.length)
                    mapDrawer.setCoordsText(tool.coordsTexts[tool.coordsTexts.length - 1], evLatLng);

                if (tool.coordsNumberTexts.length)
                    tool.coordsNumberTexts[tool.coordsNumberTexts.length - 1].set({
                        latLng: evLatLng,
                        visible: true
                    });

            } else if (tool.snapMarker)
                tool.snapMarker.setPosition(tool.getNextLatLng(null, null, latLng, mapDrawer).ToGMLatLng()); 
        }
    }

    export class DrawTool extends BaseToolIcon {
        constructor(mapDrawer: MapDrawer, name: string, title: string) {
            super(mapDrawer, name, title);
            //this.Cursor = 'crosshair';
            this.Cursor = `url("${mapDrawer.options.pathToIcons}/cursor/edit.cur"), default`;
        }

        static angleStep = Math.PI / 12;
        maxEdge: number;
        iconX = 13;
        iconY = 4;
        subMenu = [];

        step: number = 0;

        polyline: google.maps.Polygon | google.maps.Polyline = null;
        startMarker: google.maps.Marker = null;
        hoverStartMarker: boolean = false;
        snapMarker: google.maps.Marker = null;
        measureTexts: OverlayText[] = [];
        angleTexts: OverlayText[] = [];
        coordsTexts: OverlayText[] = [];
        coordsNumberTexts: OverlayText[] = [];
        linePolygonTool = new LinePolygonTool();
        circleTool = new CircleTool();
        rectangleTool = new RectangleTool();

        isMouseMoved = false;
        isMouseDown = false;
        mouseDownPoint: google.maps.LatLng = null;

        onSelect(mapDrawer: MapDrawer, prevTool: BaseToolIcon, subMenu: string) {
            this.curSubmenu = subMenu = subMenu || 'Polygon';

            const layer = mapDrawer.viewModel.currentLayer;
            if (!layer || layer.locked) {
                mapDrawer.selectTool("SelectTool");
                return;
            }

            mapDrawer.setSeparationLinesFrozen(true);

            this.step = 0;
            this.hoverStartMarker = false;
            this.measureTexts = [];
            mapDrawer.viewModel.cmdInputVal = "";

            mapDrawer.map.setOptions({ draggableCursor: this.Cursor });

            mapDrawer.setDrawingMode(true);

            const polyLineOpts: google.maps.PolylineOptions = {
                map: mapDrawer.map,
                draggable: false,
                editable: false,
                clickable: false
            };

            switch (subMenu) {
                case 'Rectangle':
                    this.polyline = new google.maps.Polygon($.extend(polyLineOpts, layer.shapeSelectedStyle) as google.maps.PolygonOptions);
                    this.measureTexts = [mapDrawer.createOverlayText(), mapDrawer.createOverlayText()];
                    break;
                case 'Circle':
                    this.polyline = new google.maps.Polyline($.extend(polyLineOpts, layer.shapeSelectedStyle) as google.maps.PolygonOptions);
                    this.measureTexts = [mapDrawer.createOverlayText()];
                    break;
                default: // 'Line', 'Polygon'
                    this.polyline = new google.maps.Polyline($.extend(polyLineOpts, layer.shapeSelectedStyle) as google.maps.PolylineOptions);
                    break;
            }
            this.createSnapMarker(mapDrawer);

            if (mapDrawer.viewModel.cmdEdgeLength <= 0)
                $('#md-input-EdgeLength').val("");

            // Reset the roof stepper info box to the "draw a roof" text when the draw tool is picked again 
            if (mapDrawer === (window as any).lsGoogleMaps?.getMapDrawer?.()) {
                (window as any).lsGoogleMaps?.notifyManualRoofToolSelected?.('DrawTool');
            }
        }

        onDeselect(mapDrawer: MapDrawer) {
            if (this.startMarker) {
                google.maps.event.clearListeners(this.startMarker, 'click');
                this.startMarker.setMap(null);
                this.startMarker = null;
            }
            if (this.snapMarker) {
                google.maps.event.clearListeners(this.snapMarker, 'click');
                this.snapMarker.setMap(null);
                this.snapMarker = null;
            }
            if (this.polyline) {
                this.polyline.setMap(null);
                this.polyline = null;
            }
            if (this.measureTexts.length) {
                this.measureTexts.forEach(ot => { ot.dispose(); });
                this.measureTexts = [];
            }
            if (this.angleTexts.length) {
                this.angleTexts.forEach(ot => { ot.dispose(); });
                this.angleTexts = [];
            }
            if (this.coordsTexts.length) {
                this.coordsTexts.forEach(ot => { ot.dispose(); });
                this.coordsTexts = [];
            }
            if (this.coordsNumberTexts.length) {
                this.coordsNumberTexts.forEach(ot => { ot.dispose(); });
                this.coordsNumberTexts = [];
            }

            mapDrawer.setSeparationLinesFrozen(false);

            this.hoverStartMarker = false;
            mapDrawer.viewModel.cmdInputVal = "";

            mapDrawer.map.setOptions({ draggableCursor: null });

            mapDrawer.setDrawingMode(false);
            
            $(document).ready(function() {
                if (mapDrawer.isFacade){
                    $("#mapViewerRoofAngle").val($("#WallAngle").val());
                }else {
                    if (!$("#mapViewerRoofAngle").val()) {
                        $("#mapViewerRoofAngle").val($("#Roof_Angle").val());
                    }
                }
                mapDrawer.viewModel.foreachItem(shape => {
                    if (shape instanceof ShapeData) {
                        if (mapDrawer.isFacade){
                            shape.setSlope($("#WallAngle").val() as string);
                        }else {
                            shape.setSlope($("#mapViewerRoofAngle").val() as string);
                        }

                    }
                })
            });
        }

        onstartMarkerMouseover(mapDrawer: MapDrawer) {
            this.hoverStartMarker = true;
        }

        onstartMarkerMouseout(mapDrawer: MapDrawer) {
            this.hoverStartMarker = false;
        }
        
        // onMouseDown
        onClick(ev: { latLng: google.maps.LatLng }, mapDrawer: MapDrawer) {
            this.isMouseDown = true;
            this.isMouseMoved = false;
            this.mouseDownPoint = ev.latLng;

            if ($.isTouchCapable()) {
                if (this.polyline && ev.latLng) {
                    if (this.curSubmenu === 'Rectangle' || this.curSubmenu === 'Circle')
                        mapDrawer.map.setOptions({ draggable: false });

                    let path = this.polyline.getPath();
                    if (this.curSubmenu === 'Rectangle') {
                        let gmevLatLng = this.getNextLatLng(null, null, LatLng.FromGMLatLng(ev.latLng), mapDrawer).ToGMLatLng();
                        path.push(gmevLatLng);
                        path.push(gmevLatLng);
                        path.push(gmevLatLng);
                        path.push(gmevLatLng);
                        this.step = 1;
                    }
                    else if (this.curSubmenu === 'Circle') {
                        let gmevLatLng = this.getNextLatLng(null, null, LatLng.FromGMLatLng(ev.latLng), mapDrawer).ToGMLatLng();
                        path.push(gmevLatLng);
                        path.push(gmevLatLng);
                        this.step = 0;
                    }
                }
            }
        }

        onMouseUp(ev: { latLng: google.maps.LatLng }, mapDrawer: MapDrawer) {
            mapDrawer.map.setOptions({ draggable: true });

            if (!$.isTouchCapable() && (this.curSubmenu === 'Rectangle' || this.curSubmenu === 'Circle') && (this.isMouseMoved || this.isDragging))
                return;

            // Use a movement threshold for drag detection.
            // Prevents clicks from being lost due to minor cursor movement.
            let movedBeyondTap = false;
            if (!$.isTouchCapable() && this.mouseDownPoint && ev.latLng) {
                const proj = mapDrawer.map.getProjection();
                if (proj) {
                    const scale = Math.pow(2, mapDrawer.map.getZoom());
                    const a = proj.fromLatLngToPoint(this.mouseDownPoint);
                    const b = proj.fromLatLngToPoint(ev.latLng);
                    const mdx = (a.x - b.x) * scale;
                    const mdy = (a.y - b.y) * scale;
                    movedBeyondTap = mdx * mdx + mdy * mdy > 15 * 15;
                }
            }

            if (this.curSubmenu !== 'Rectangle' && this.curSubmenu !== 'Circle' && this.isMouseDown && (this.isDragging || movedBeyondTap))
                return;

            if ($.isTouchCapable() && (this.curSubmenu === 'Rectangle' || this.curSubmenu === 'Circle') && this.isMouseDown && !this.isMouseMoved && !this.isDragging) {
                let path = this.polyline.getPath();
                path.clear();
                return;
            }

            if ($.isTouchCapable())
                this.onMousemove(ev, mapDrawer);

            const polyLine = this.polyline;
            if (polyLine && ev.latLng) {
                if (!this.canDrawHere(mapDrawer, ev.latLng)) {
                    //reset bool events
                    this.isMouseDown = false;
                    this.isMouseMoved = false;
                    return;
                }

                const context: DrawingContext = {
                    mapDrawer,
                    tool: this
                };

                switch(this.curSubmenu) {
                    case DrawingToolEnum.Rectangle:
                        this.rectangleTool.handleClick(ev, context);
                        break;
                    case DrawingToolEnum.Circle:
                        this.circleTool.handleClick(ev, context);
                        break;
                    default:
                        this.linePolygonTool.handleClick(ev, context);
                        break;
                }
            }

            //reset bool events
            this.isMouseDown = false;
            this.isMouseMoved = false;
        }

        createSnapMarker(mapDrawer: MapDrawer) {
            if (!this.snapMarker) {
                const iconSnap: google.maps.Symbol = {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 3,
                    strokeWeight: 1,
                    strokeOpacity: 0,
                    fillOpacity: 1
                };
                const layer = mapDrawer.viewModel.currentLayer;

                if (layer) {
                    iconSnap.fillColor = layer.shapeSelectedStyle.strokeColor;
                    iconSnap.fillOpacity = layer.shapeSelectedStyle.strokeOpacity;
                    iconSnap.scale = layer.shapeSelectedStyle.strokeWeight * 3;
                }
                const b = mapDrawer.map.getBounds();

                this.snapMarker = new google.maps.Marker({
                    map: mapDrawer.map,
                    clickable: false,
                    draggable: false,
                    position: b ? b.getSouthWest() : mapDrawer.map.getCenter(),
                    icon: iconSnap
                });

                this.snapMarker.setVisible(false);
            }
        }

        onKeyDown(key: string, mapDrawer: MapDrawer) {
            if (key === 'Shift' || key === 'Control') //shift, ctrl
                this.updateDrawing(mapDrawer);
        }

        onKeyUp(key: string, mapDrawer: MapDrawer) {
            if (key === 'Shift' || key === 'Control') //shift, ctrl
                this.updateDrawing(mapDrawer);
        }

        updateDrawing(mapDrawer: MapDrawer) {
            const context: DrawingContext = {
                mapDrawer,
                tool: this
            };
            
            if (this.curSubmenu === 'Rectangle' && this.step === 1 && this.polyline)
                this.rectangleTool.draw(context, this.polyline.getPath(), null);
            else if (this.curSubmenu === 'Circle' && this.step === 1 && this.polyline)
                this.circleTool.draw(context, this.polyline.getPath(), null);
        }

        onMousemove(ev: { latLng: google.maps.LatLng }, mapDrawer: MapDrawer) {
            const polyLine = this.polyline,
                curSubmenu = this.curSubmenu;
            
            const context: DrawingContext = {
                mapDrawer,
                tool: this
            };
            
            if (polyLine && ev.latLng) {
                const path = this.polyline.getPath();
                
                if(this.step === 0) {
                    this.snapMarker.setPosition(this.getNextLatLng(null, null, LatLng.FromGMLatLng(ev.latLng), mapDrawer).ToGMLatLng());
                }
                
                if (curSubmenu === DrawingToolEnum.Rectangle && this.step === 1) {
                    //Rectangle
                    const evLatLng = this.getNextLatLng(null, null, LatLng.FromGMLatLng(ev.latLng), mapDrawer);

                    if (this.snapMarker)
                        this.snapMarker.setPosition(evLatLng.ToGMLatLng());

                    this.rectangleTool.draw(context, path, evLatLng);
                }
                else if (curSubmenu === DrawingToolEnum.Circle && this.step === 1) {
                    //Circle
                    const latLngFirst = path.getLength() > 0 ? LatLng.FromGMLatLng(path.getAt(0)) : null;
                    let evLatLng = this.getNextLatLng(null, latLngFirst, LatLng.FromGMLatLng(ev.latLng), mapDrawer);

                    if (this.snapMarker)
                        this.snapMarker.setPosition(evLatLng.ToGMLatLng());

                    this.circleTool.draw(context, path, evLatLng);
                }
                else {
                    //Line or Polygon
                    this.linePolygonTool.draw(context, path, LatLng.FromGMLatLng(ev.latLng));
                }
            } else if (this.snapMarker)
                this.snapMarker.setPosition(this.getNextLatLng(null, null, LatLng.FromGMLatLng(ev.latLng), mapDrawer).ToGMLatLng());

            if (this.snapMarker && this.snapped !== this.snapMarker.getVisible())
                this.snapMarker.setVisible(this.snapped);

            this.isMouseMoved = true;
        }

        onPolylineClosed(mapDrawer: MapDrawer) {
            const { polyline, curSubmenu } = this;
            const layer = mapDrawer.viewModel.currentLayer;

            if (!polyline || !layer) {
                mapDrawer.selectTool(this.name, curSubmenu);
                return;
            }

            const path = polyline.getPath();
            const isLine = curSubmenu === DrawingToolEnum.Line;

            // Minimum vertices requirement
            if (!path || (isLine ? path.getLength() <= 2 : path.getLength() <= 3)) {
                mapDrawer.selectTool(this.name, curSubmenu);
                return;
            }

            const context: DrawingContext = { mapDrawer, tool: this };

            switch (curSubmenu) {
                case DrawingToolEnum.Line:
                case DrawingToolEnum.Polygon:
                    this.linePolygonTool.handleClose(context);
                    break;
                case DrawingToolEnum.Circle:
                    this.circleTool.handleClose(context);
                    break;
            }

            const pathArray = path.getArray();
            const poly = new google.maps.Polygon({ paths: pathArray });

            // ---- Free Areas should not overlap each other ----
            if (pathArray.length > 2 && layer.typeName === window.FreeAreaTypeName) {
                const freeArea = mapDrawer.viewModel.layer.freeArea.polygons ?? [];

                for (const polygon of freeArea) {
                    const gmPaths = polygon.getPaths().getArray().map(p =>
                        p.getArray().map(ll => ({ lat: ll.lat(), lng: ll.lng() }))
                    );

                    const borderPoly = new google.maps.Polygon({ paths: gmPaths });

                    if (polygonsOverlap(poly, borderPoly)) {
                        mapDrawer.selectTool(this.name, curSubmenu);
                        return;
                    }
                }
            }

            // ---- Shape should not be outside area ----
            const areaPolygons = mapDrawer.viewModel.layer.area?.polygons ?? [];
            if (areaPolygons.length) {
                let insideAnyArea = false;

                for (const area of areaPolygons) {
                    const pol = new google.maps.Polygon();
                    pol.setPath(area.getPaths().getAt(0));

                    const allInside = pathArray.every(v =>
                        google.maps.geometry.poly.containsLocation(v, pol)
                    );

                    if (allInside) {
                        insideAnyArea = true;
                    }
                }

                if (!insideAnyArea) {
                    mapDrawer.selectTool(this.name, curSubmenu);
                    return;
                }
            }

            if (pathArray.length > 2) {
                mapDrawer.onOverlaycomplete(new google.maps.Polygon({ paths: pathArray }));

                if (layer.typeName === "Building")
                    lsGoogleMaps.refreshStepNumber(2);

                mapDrawer.selectTool(this.name, curSubmenu);
            }
        }

        onCommandText(mapDrawer: MapDrawer, cmd: string) {
            if (cmd && typeof cmd === "string" && cmd.length) {
                var inputSplit = cmd.split(",");
                if (inputSplit.length === 2) {
                    var xStr = inputSplit[0];
                    var yStr = inputSplit[1];

                    var valueAdjustOpts = mapDrawer.viewModel.valueAdjustOpts;
                    var imperial = window.UseImperialSystem;

                    var xVal = spt.Utils.GetFloatFromInputValue("" + xStr,
                        {
                            applyArithmetic: true,
                            isFeet: imperial,
                            notImperial: !imperial,
                            from: valueAdjustOpts.to,
                            to: "m"
                        });

                    var yVal = spt.Utils.GetFloatFromInputValue("" + yStr,
                        {
                            applyArithmetic: true,
                            isFeet: imperial,
                            notImperial: !imperial,
                            from: valueAdjustOpts.to,
                            to: "m"
                        });

                    if (xVal === null || isNaN(xVal) || !isFinite(xVal) || yVal === null || isNaN(yVal) || !isFinite(yVal))
                        return;

                    var rp = mapDrawer.viewModel.referenceLatLng;

                    var path = this.polyline ? this.polyline.getPath() : null,
                        pathLength = path ? path.getLength() : null;

                    if (!path)
                        return;

                    if (mapDrawer.viewModel.coordsRelative) {
                        if (pathLength)
                            rp = LatLng.FromGMLatLng(path.getAt(pathLength - 1));
                    }

                    var latLng = rp.Offset(+yVal, +xVal);

                    if (pathLength && this.curSubmenu === 'Polygon') {
                        var fp = LatLng.FromGMLatLng(path.getAt(0));
                        if (fp.Equals(latLng)) {
                            this.onPolylineClosed(mapDrawer);
                            return;
                        }
                        var lp = LatLng.FromGMLatLng(path.getAt(pathLength - 1));
                        if (lp.Equals(latLng))
                            return;
                    }

                    this.onMousemove({ latLng: latLng.ToGMLatLng() }, mapDrawer);
                    this.onMouseUp({ latLng: latLng.ToGMLatLng() }, mapDrawer);

                    path = this.polyline ? this.polyline.getPath() : null;
                    pathLength = path ? path.getLength() : null;

                    var bds = BoundsLatLng.FromGmLatLngs(path);
                    if (bds.Width < 50 || bds.Height < 50)
                        bds = BoundsLatLng.FromCenterWidthHeight(bds.Center, Math.max(50, bds.Width), Math.max(50, bds.Height));

                    mapDrawer.map.fitBounds(bds.ToGMLatLngBounds());
                }
            }
        }

        private canDrawHere(mapDrawer: MapDrawer, latLng: google.maps.LatLng) {
            const { currentLayer, layer } = mapDrawer.viewModel;
            
            if(!currentLayer) return;
            
            switch (currentLayer.typeName) {
                case window.FreeAreaTypeName:
                {
                    const isInsideAreaLayer = isLatLngInsidePolygon(mapDrawer, latLng, window.AreaTypeName);
                    if(!isInsideAreaLayer)
                        return false;

                    if(!layer.freeArea.polygons.length) return true;
                    
                    const isInsideFreeAreaLayer = isLatLngInsidePolygon(mapDrawer, latLng, window.FreeAreaTypeName);
                    return !isInsideFreeAreaLayer;
                }
                case window.InterfernceLayerName:
                {
                    return isLatLngInsidePolygon(mapDrawer, latLng, window.AreaTypeName);
                }
                default:
                    return true;
            }
        }
    }

    export class HelperLinesTool extends BaseToolIcon {
        constructor(mapDrawer: MapDrawer, name: string, title: string) {
            super(mapDrawer, name, title);
            this.Cursor = 'crosshair';
        }

        iconX = 3;
        iconY = 4;

        helperLine: Helperline = null;
        snapMarker: google.maps.Marker = null;
        step: number = 0;

        onSelect(mapDrawer: MapDrawer, prevTool: BaseToolIcon, subMenu: string) {
            mapDrawer.map.setOptions({ draggableCursor: this.Cursor });

            mapDrawer.setSeparationLinesFrozen(true);

            mapDrawer.clearSelection();

            var c = LatLng.FromGMLatLng(mapDrawer.map.getCenter());

            this.step = 0;

            this.helperLine = this.createHelperLine(c, mapDrawer);

            this.snapMarker = new google.maps.Marker({
                map: mapDrawer.map,
                clickable: false,
                draggable: false,
                visible: false,
                position: c.ToGMLatLng(),
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: Helperline.shapeStyle.strokeWeight * 3,
                    fillColor: Helperline.shapeStyle.strokeColor,
                    fillOpacity: Helperline.shapeStyle.strokeOpacity,
                    strokeOpacity: 0
                },
                zIndex: 0
            });

        }

        onDeselect(mapDrawer: MapDrawer) {

            mapDrawer.setSeparationLinesFrozen(false);

            if (this.helperLine) {
                this.helperLine.setMap(null);
                this.helperLine = null;
            }
            if (this.snapMarker) {
                this.snapMarker.setMap(null);
                this.snapMarker = null;
            }

            mapDrawer.map.setOptions({ draggableCursor: null });

        }

        private createHelperLine(c: LatLng, mapDrawer: MapDrawer): Helperline {
            var helperLine = new Helperline(mapDrawer, c, c);
            helperLine.locked = true;
            return helperLine;
        }

        onClick(ev: google.maps.MouseEvent, mapDrawer: MapDrawer) {
            var helperLine = this.helperLine,
                snapMarker = this.snapMarker;
            if (helperLine && ev.latLng) {
                switch (this.step) {
                    case 0:
                        {
                            let curll = LatLng.FromGMLatLng(ev.latLng),
                                ll = HelperLinesTool.getSnapPosition(null, curll, mapDrawer);
                            if (!ll) {
                                ll = curll;
                                this.snapped = false;
                            } else
                                this.snapped = true;
                            helperLine.setStartEnd(ll, ll);
                            snapMarker.setPosition(ll.ToGMLatLng());
                            this.step = 1;
                        }
                        break;
                    case 1:
                        {
                            let curll = LatLng.FromGMLatLng(ev.latLng),
                                ll = HelperLinesTool.getSnapPosition(helperLine.Start, curll, mapDrawer);
                            if (!ll) {
                                ll = curll;
                                this.snapped = false;
                            } else
                                this.snapped = true;
                            helperLine.End = ll;
                            snapMarker.setPosition(ll.ToGMLatLng());
                            this.helperLine.frozen = true;
                            this.helperLine.locked = false;

                            mapDrawer.viewModel.helperLines.push(this.helperLine);
                            this.helperLine = this.createHelperLine(ll, mapDrawer);
                            this.step = 0;
                        }
                        break;
                }
                snapMarker.setVisible(false);
            }
        }

        onMousemove(ev: google.maps.MouseEvent, mapDrawer: MapDrawer) {
            var helperLine = this.helperLine,
                snapMarker = this.snapMarker;
            if (helperLine && ev.latLng) {
                switch (this.step) {
                    case 0:
                        {
                            let curll = LatLng.FromGMLatLng(ev.latLng),
                                ll = HelperLinesTool.getSnapPosition(null, curll, mapDrawer);
                            if (!ll) {
                                ll = curll;
                                this.snapped = false;
                            } else
                                this.snapped = true;
                            helperLine.setStartEnd(ll, ll);
                            snapMarker.setPosition(ll.ToGMLatLng());
                        }
                        break;
                    case 1:
                        {
                            let curll = LatLng.FromGMLatLng(ev.latLng),
                                ll = HelperLinesTool.getSnapPosition(helperLine.Start, curll, mapDrawer);
                            if (!ll) {
                                ll = curll;
                                this.snapped = false;
                            } else
                                this.snapped = true;
                            helperLine.End = ll;
                            snapMarker.setPosition(ll.ToGMLatLng());
                        }
                        break;
                }
                if (this.snapped !== snapMarker.getVisible())
                    snapMarker.setVisible(this.snapped);
            }
        }

        static getSnapPosition(prevLatLng: LatLng, curLatLng: LatLng, mapDrawer: MapDrawer, layers?: PolygonLayer[], snapInfo?: { isHelperLine: boolean }): LatLng {
            let result: LatLng = null,
                clickTolerance = Helperline.clickTolerance;

            const ptInfo  = snapInfo ? { isHelperLine: false } : undefined;
            const segInfo = snapInfo ? { isHelperLine: false } : undefined;
            let pt = mapDrawer.getPointByPoint(curLatLng, clickTolerance, true, true, layers, undefined, ptInfo),
                seg = !pt ? mapDrawer.getSegmentByPoint(curLatLng, clickTolerance, layers, undefined, undefined, segInfo) : null;

            if (prevLatLng && mapDrawer.shiftDown) {
                let helperlinesResult = Helperline.GetSnapByHelperlines(null, prevLatLng, LatLng.FromPoint2D(pt) || LatLng.FromPoint2D(seg && seg.getClosestPoint(curLatLng.ToPoint2D())) || curLatLng, mapDrawer, true, false);
                if (curLatLng.DistanceTo(helperlinesResult.result) > 0.01) {
                    if (pt)
                        result = helperlinesResult.result;
                    else if (seg && prevLatLng.DistanceTo(helperlinesResult.result) > 0.01) {
                        var inter = seg.getIntersection(new Segment2D(prevLatLng.ToPoint2D(), helperlinesResult.result.ToPoint2D(), true));
                        if (inter) {
                            var pxFactor = Math.pow(2, mapDrawer.map.getZoom()),
                                dist = inter.DistanceTo(helperlinesResult.result.ToPoint2D()) * pxFactor;
                            if (dist <= clickTolerance)
                                result = LatLng.FromPoint2D(inter);
                        }
                    }
                    if (!result)
                        result = helperlinesResult.result;
                    if (snapInfo)
                        snapInfo.isHelperLine = true;
                }
            }

            if (!result) {
                if (pt) {
                    result = LatLng.FromPoint2D(pt);
                    if (snapInfo && ptInfo)
                        snapInfo.isHelperLine = ptInfo.isHelperLine;
                } else if (seg) {
                    var sp = seg.getClosestPoint(curLatLng.ToPoint2D());
                    if (sp) {
                        result = LatLng.FromPoint2D(sp);
                        if (snapInfo && segInfo)
                            snapInfo.isHelperLine = segInfo.isHelperLine;
                    }
                }
            }

            //if (!result && prevLatLng && mapDrawer.shiftDown) {
            //    let helperlinesResult = Helperline.GetSnapByHelperlines(prevLatLng, curLatLng, mapDrawer, true, false).result;
            //    if (curLatLng.DistanceTo(helperlinesResult) > 0.01)
            //        result = helperlinesResult;
            //}

            return result;
        }

    }

    export class SouthMarkerTool extends BaseToolIcon {
        constructor(mapDrawer: MapDrawer, name: string, title?: string) {
            super(mapDrawer, name, title);
            // this.Cursor = `url("${mapDrawer.options.pathToIcons}/cursor/south.cur"), default`;
        }

        iconX = 15;
        iconY = 4;
        
        customIconX = 13;
        customIconY = 8;

        segments: { [id: string]: Segment2D[] } = null;
        polyline: google.maps.Polyline = null;

        southMarker: SouthMarker = null;
        currentPolyId: string = null;
        southMarkerHovered: boolean = false;

        useCustomSouthMarker: boolean = false;

        static clickTolerance = 25;

        static highlightStyle: IShapeStyle = {
            strokeWeight: 3,
            strokeColor: '#FFFFFF',
            strokeOpacity: 0.4
        };

        onSelect(mapDrawer: MapDrawer, prevTool: BaseToolIcon, subMenu: string) {
            var viewmodel = mapDrawer.viewModel,
                layer = viewmodel.layer.mainLayer,
                polys = layer.polygons;

            // Apply orientation changes only to the selected face of a multi-face roof.
            // Allows independent correction.
            const selectedChild = (viewmodel.layer.roof?.polygons ?? []).map(p => p.userData as ShapeData).find(d => d?.selected);
            this.useCustomSouthMarker = !!(selectedChild && selectedChild.parent?.children?.length > 1);

            if(viewmodel.editorMode === EditorModeEnum.FreeArea && viewmodel.layer.mainLayer.count < 1) {
                layer = viewmodel.layer.area;
                polys = layer.polygons;
            }

            if (this.useCustomSouthMarker) {
                layer = viewmodel.layer.roof ?? viewmodel.layer.area;
                if(layer?.polygons?.length) {
                    polys = layer.polygons.slice(); //Copy array
                    let selectedPolys = polys.filter(poly => poly.userData.selected);
                    
                    if (selectedPolys.length > 0) {
                        polys = selectedPolys; //A user can set southMarkers only for selected roofs.
                    }
                }
            }

            if (!polys.length) {
                mapDrawer.selectTool("SelectTool");
                return;
            }

            this.segments = {};
            this.currentPolyId = null;
            this.southMarkerHovered = false;

            polys.forEach(poly => {
                var data = poly.userData as ShapeData;
                if (data && !data._isDisposed) {
                    var segments = data.getSegments();
                    if (segments && segments.length) {
                        this.segments[data.id] = segments;
                    }
                    if (data.southMarker) {
                        var southMarker = data.southMarker;
                        southMarker.clickable = true;
                        southMarker.hovered = false;
                    }
                }
            });

            mapDrawer.map.setOptions({ draggableCursor: null });

            var polyLineOpts: google.maps.PolylineOptions = {
                map: mapDrawer.map,
                draggable: false,
                editable: false,
                clickable: false,
                visible: false,
                zIndex: 12,
                strokeWeight: layer.shapeSelectedHoveredStyle.strokeWeight + 2,
                strokeColor: layer.shapeSelectedHoveredStyle.strokeColor,
                strokeOpacity: 0.5
            };

            this.polyline = new google.maps.Polyline(polyLineOpts);

            this.southMarker = this.createSouthMarker(mapDrawer);
        }

        onDeselect(mapDrawer: MapDrawer) {
            var viewmodel = mapDrawer.viewModel,
                layer = viewmodel.layer.mainLayer,
                polys = layer.polygons;

            if (this.useCustomSouthMarker) {
                layer = viewmodel.layer.roof ?? viewmodel.layer.area;
                
                if(layer?.polygons?.length) polys = layer.polygons;
            }

            this.segments = null;
            this.currentPolyId = null;
            if (this.southMarker) {
                this.southMarker.dispose();
                this.southMarker = null;
            }
            if (this.polyline) {
                this.polyline.setMap(null);
                this.polyline = null;
            }
            this.southMarkerHovered = false;
            if (polys) {
                polys.forEach(poly => {
                    var data = poly.userData as ShapeData;
                    if (data && !data._isDisposed && data.southMarker) {
                        var southMarker = data.southMarker;
                        southMarker.clickable = false;
                        southMarker.hovered = false;
                    }
                });
            }
            mapDrawer.map.setOptions({ draggableCursor: null });
            this.useCustomSouthMarker = false;
        }

        createSouthMarker(mapDrawer: MapDrawer): SouthMarker {
            return new SouthMarker(null, 0, false, mapDrawer);
        }

        getPolyForSouthMarker(mapDrawer: MapDrawer) : IGoogleMapsPolygon {
            
            let viewmodel = mapDrawer.viewModel;
            
            //if no FreeArea was drawn but a GenericArea exists, a freeArea is created with the configuration of the GenericArea
            if(viewmodel.editorMode === EditorModeEnum.FreeArea && viewmodel.layer.mainLayer.count < 1) {
                let areaPoly = viewmodel.layer.area.polygons.slice();
                if(areaPoly.length < 1)
                    return null;

                let newFreeAreaPoly = new google.maps.Polygon({paths: areaPoly[0].getPaths()});
                newFreeAreaPoly.userData = new ShapeData(mapDrawer, newFreeAreaPoly, spt.Utils.GenerateGuid(), "FreeArea", viewmodel.layer.freeArea.typeName);
                viewmodel.currentLayer = viewmodel.layer.freeArea;
                this.currentPolyId = newFreeAreaPoly.userData.id;
                mapDrawer.addPolygon(newFreeAreaPoly);
                return newFreeAreaPoly;
            }
            else {
                return viewmodel.layer.mainLayer.getPolygonById(this.currentPolyId);
            }
        }
        
        onMouseUp(ev: google.maps.MouseEvent, mapDrawer: MapDrawer) {
            if ($.isTouchCapable()) {
                if (this.isDragging)
                    return;
                else
                    this.onMousemove(ev, mapDrawer);
            }

            if (this.southMarker && this.southMarker.visible && this.currentPolyId) {

                var viewmodel = mapDrawer.viewModel,
                    layer = viewmodel.layer.mainLayer,
                    poly = this.getPolyForSouthMarker(mapDrawer);

                if (this.useCustomSouthMarker) {
                    layer = viewmodel.layer.roof ?? viewmodel.layer.area;

                    if(layer?.polygons?.length) poly = layer.getPolygonById(this.currentPolyId);
                }

                if (poly) {
                    var data = poly.userData as ShapeData;
                    // Apply the marker to the selected face only.
                    // Recompute the building so all faces use the updated orientation.
                    var building = this.useCustomSouthMarker ? this.getBuilding(data) : null;
                    this.removeSouthmarker(data);
                    if (data) {
                        data.southMarker = this.southMarker;
                        data.useCustomSouthMarker = this.useCustomSouthMarker;
                        this.southMarker = null;
                        data.update();
                        if (building) {
                            building.regenerate();
                        } else {
                            data.regenerate();
                        }
                        // Only prompt for roof settings when the roof has no height yet.
                        // Re-placing the south marker on an already-configured roof must not reopen the settings modal
                        const roofAlreadyConfigured = ((data?.height ?? 0) > 0);
                        lsGoogleMaps.refreshStepNumber(roofAlreadyConfigured ? 117 : 3);
                        if (this.useCustomSouthMarker) {
                            mapDrawer.clearSelection();
                            mapDrawer.selectTool("SelectTool");
                        } else if (!$.isTouchCapable()) {
                            if (layer.polygons.length > 1)
                                mapDrawer.selectTool("SouthMarkerTool", this.curSubmenu);
                            else
                                mapDrawer.selectTool("SelectTool");
                        }
                        else {
                            mapDrawer.selectTool("SouthMarkerTool", this.curSubmenu);
                        }

                        (window as any).lsGoogleMaps?.selectManualRoofAfterSouthMarker?.(data.id);

                        if ((window as any).mapDrawerWizard) {
                            (window as any).mapDrawerWizard.setStepSouthMarker(true);
                            (window as any).mapDrawerWizard.show();
                        }
                    }
                }
            }
        }

        // onMouseDown
        onClick(ev: google.maps.MouseEvent, mapDrawer: MapDrawer) {

        }

        onMousemove(ev: google.maps.MouseEvent, mapDrawer: MapDrawer) {
            var polyLine = this.polyline,
                found = false,
                southMarkerHovered = this.southMarkerHovered;

            if (polyLine && ev.latLng && !southMarkerHovered) {
                var latLng = LatLng.FromGMLatLng(ev.latLng),
                    p = latLng.ToPoint2D();
                var s = this.tryGetSegment(p, mapDrawer);
                if (s) {

                    var seg = s.segment,
                        center = seg.getCenter(),
                        orientation = seg.getOrientation(),
                        normal = seg.Normal;

                    if (normal.dot(p.sub(seg.Start)) > 0) {
                        orientation += Math.PI;
                    }

                    this.currentPolyId = s.id;

                    this.southMarker.position = LatLng.FromPoint2D(center);
                    this.southMarker.orientation = orientation;
                    this.southMarker.visible = true;

                    this.polyline.setPath([LatLng.Point2DToGMLatLng(seg.Start), LatLng.Point2DToGMLatLng(seg.End)]);
                    this.polyline.setVisible(true);

                    mapDrawer.map.setOptions({ draggableCursor: 'pointer' });

                    found = true;
                }
            }

            if (!found) {
                this.currentPolyId = null;
                this.southMarker.visible = false;
                this.polyline.setVisible(false);
                mapDrawer.map.setOptions({ draggableCursor: null });
            }
        }

        tryGetSegment(p: Point2D, mapDrawer: MapDrawer): { id: string, segment: Segment2D } {
            var result: { id: string, segment: Segment2D } = null;
            if (this.segments) {
                var minDist = Number.MAX_VALUE,
                    clickTolerance = SouthMarkerTool.clickTolerance,
                    pxFactor = mapDrawer.getPixelFactor(),
                    foundSeg: Segment2D = null,
                    foundId: string = null;

                Object.keys(this.segments).forEach(k => {
                    this.segments[k].forEach(seg => {
                        var dist = seg.distanceToPoint(p) * pxFactor;
                        if (dist <= clickTolerance && dist < minDist) {
                            minDist = dist;
                            foundSeg = seg;
                            foundId = k;
                        }
                    });
                });

                if (foundSeg && foundId) {
                    result = {
                        segment: foundSeg,
                        id: foundId
                    };
                }
            }

            return result;
        }

        onMouseoverSouthMarker(southMarker: SouthMarker, mapDrawer: MapDrawer) {
            this.southMarkerHovered = true;
            southMarker.hovered = true;
        }

        onMouseoutSouthMarker(southMarker: SouthMarker, mapDrawer: MapDrawer) {
            this.southMarkerHovered = false;
            southMarker.hovered = false;
        }

        onClickSouthMarker(southMarker: SouthMarker, mapDrawer: MapDrawer) {
            var viewmodel = mapDrawer.viewModel,
                layer = viewmodel.layer.mainLayer,
                polys = layer.polygons;

            if (southMarker && polys.length) {
                polys.filter(poly => poly && poly.userData && (poly.userData as ShapeData).southMarker && (poly.userData as ShapeData).southMarker.id === southMarker.id).forEach(poly => {
                    this.removeSouthmarker(poly.userData as ShapeData);
                });
            }

            this.southMarkerHovered = false;
        }

        removeSouthmarker(shape: ShapeData) {
            if (shape && shape.southMarker) {
                shape.southMarker.dispose();
                shape.southMarker = null;
            }
        }

        getBuilding(shape: ShapeData): ShapeData {
            return this.getParentShapeByType(shape, window.BuildingTypeName);
        }

        getParentShapeByType(shape: ShapeData, typeName: string): ShapeData {
            if (shape.typeName === typeName) {
                return shape;
            }
            while(shape && shape.parent) {
                shape = shape.parent;
                if (shape.typeName === typeName) {
                    return shape;
                }
            }
            return null;
        }
    }

    export class EraserTool extends BaseToolIcon {
        constructor(mapDrawer: MapDrawer, name: string, title: string) {
            super(mapDrawer, name, title);
            this.Cursor = '';//`url("${mapDrawer.options.pathToIcons}/cursor/eraser.cur"), default`;
        }

        iconX = 5;
        iconY = 1;

        onSelect(mapDrawer: MapDrawer, prevTool: BaseToolIcon, subMenu: string) {
            if (!mapDrawer.eraseMode) {
                mapDrawer.eraseMode = true;
                mapDrawer.map.setOptions({ draggableCursor: this.Cursor });
            }
        }

        onDeselect(mapDrawer: MapDrawer) {
            if (mapDrawer.eraseMode) {
                mapDrawer.eraseMode = false;
                mapDrawer.map.setOptions({ draggableCursor: null });
            }
        }
    }

    export class GoToLocationTool extends BaseToolIcon {
        onSelect(mapDrawer: MapDrawer, prevTool: BaseToolIcon, subMenu: string) {
            const viewModel = mapDrawer.viewModel;

            if(viewModel){
                viewModel.moveToProjectAddress();
                if (!viewModel.isDrawingMode) {
                    mapDrawer.selectTool("Gis3DBuildingsTool");
                }
                else {
                    mapDrawer.selectTool(prevTool.name);
                }
            }
        }
    }

    export class Unselect3DBuildingsTool extends BaseToolIcon {
        onSelect(mapDrawer: MapDrawer, prevTool: BaseToolIcon, subMenu: string) {
            const viewModel = mapDrawer.viewModel;

            if (viewModel) {
                mapDrawer.deleteAll();
                $('#slopeForAllRoofs').addClass("hidden");
            }

            const gis3dTool = viewModel?.toolIcons?.["Gis3DBuildingsTool"] as Gis3DBuildingsTool | undefined;
            mapDrawer.selectTool("Gis3DBuildingsTool");
            gis3dTool?.cancelRestore();
            gis3dTool?.restartBuildingSelection();
        }
    }

    export class OsmBuildingsTool extends BaseToolIcon {
        buildingClicked(mapDrawer: MapDrawer, poly: google.maps.Polygon) {
            var buildingsLayer = mapDrawer.viewModel.layer.building;
            if (poly && buildingsLayer) {
                var path = poly.getPath();
                if (path && path.getLength() > 3) {

                    if (buildingsLayer.polygons.length)
                        mapDrawer.deleteSelectables(buildingsLayer.polygons.map(rp => rp.userData as ShapeData).filter(d => !!d));

                    mapDrawer.viewModel.currentLayer = buildingsLayer;

                    mapDrawer.onOverlaycomplete(new google.maps.Polygon({ paths: path.getArray() }), true);
                }
            }
            mapDrawer.selectTool("SelectTool");
        }

        onSelect(mapDrawer: MapDrawer) {
            mapDrawer.osmBuildings.start(mapDrawer, this.buildingClicked.bind(this, mapDrawer));
        }

        onDeselect(mapDrawer: MapDrawer) {
            mapDrawer.osmBuildings.stop();
        }
    }

    export class SimpleRidgeTool extends BaseToolIcon {
        constructor(mapDrawer: MapDrawer, name: string, title: string) {
            super(mapDrawer, name, title);
            this.Cursor = 'crosshair';
        }

        iconX = 15;
        iconY = 8;

        target: ShapeData = null;
        separationPolyline: SeparationPolyline = null;
        private polyLine: google.maps.Polyline = null;
        private snapMarker: google.maps.Marker = null;
        step: number = 0;
        private snappedOnHelperLine: boolean = false;

        onSelect(mapDrawer: MapDrawer, prevTool: BaseToolIcon, subMenu: string) {
            const buildingPolys = mapDrawer.viewModel.layer.building?.polygons;

            if (!buildingPolys?.length) {
                mapDrawer.selectTool("SelectTool");
                return;
            }

            // Capture selection before clearSelection() wipes it.
            const selectedBuilding = mapDrawer.viewModel.selection
                .find((item: any) => item?.typeName === (window as any).BuildingTypeName) as ShapeData ?? null;

            mapDrawer.clearSelection();
            buildingPolys.forEach(poly =>
                (poly.userData as ShapeData).separationPolylines.forEach(sp => sp.frozen = true)
            );

            // Use the selected building if one is selected, else use the last (most recently drawn) building.
            // _doPlacement auto-switches target when the user clicks on a different building.
            this.target = selectedBuilding ?? (buildingPolys[buildingPolys.length - 1].userData as ShapeData);
            this.target.useSimpleRidgeTool = true;
            this.step = 0;
            this.separationPolyline = null;

            // Show roof areas overlays for all existing children (built by a previous ridge).
            refreshRoofOverlays();

            const center = LatLng.FromGMLatLng(mapDrawer.map.getCenter());
            const shapeStyle = $.extend({}, SeparationPolyline.shapeStyle, { strokeWeight: SeparationPolyline.shapeStyle.strokeWeight * 2, strokeOpacity: 1 });

            this.polyLine = new google.maps.Polyline($.extend({
                map: mapDrawer.map,
                draggable: false,
                editable: false,
                clickable: false,
                visible: false,
                zIndex: 0,
                path: [center.ToGMLatLng(), center.ToGMLatLng()]
            }, shapeStyle) as google.maps.PolylineOptions);

            this.snapMarker = new google.maps.Marker({
                map: mapDrawer.map,
                clickable: false,
                draggable: false,
                visible: false,
                position: center.ToGMLatLng(),
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 10,
                    fillColor: shapeStyle.strokeColor,
                    fillOpacity: 1,
                    strokeColor: '#ffffff',
                    strokeWeight: 2,
                    strokeOpacity: 1
                },
                zIndex: 0
            });

            mapDrawer.setDrawingMode(true);
            mapDrawer.map.setOptions({ draggableCursor: this.Cursor });
        }

        onDeselect(mapDrawer: MapDrawer) {
            const layer = mapDrawer.viewModel.layer.building;
            if (layer) {
                layer.polygons.forEach(poly =>
                    (poly.userData as ShapeData).separationPolylines.forEach(sp => sp.frozen = false)
                );
            }

            if (this.snapMarker) {
                this.snapMarker.setMap(null);
                this.snapMarker = null;
            }
            if (this.polyLine) {
                this.polyLine.setMap(null);
                this.polyLine = null;
            }

            const target = this.target;
            const hasRidges = (target?.separationPolylines?.length ?? 0) > 0;
            const hasHeight = (target as any)?.height > 0;

            if (target) {
                target.suppressRegenerate = false;
                // Do NOT reset useSimpleRidgeTool here — it is a permanent property of the
                // building that controls how regenerate() groups child shapes. Resetting it
                // causes incorrect area calculation on reload and after page navigation.
            }

            this.target = null;
            this.separationPolyline = null;
            this.step = 0;

            mapDrawer.setDrawingMode(false);
            mapDrawer.map.setOptions({ draggableCursor: null });

            refreshRoofOverlays();

            if (hasRidges && !hasHeight) {
                (window as any).lsGoogleMaps?.triggerRoofSettingsHelperAfterRidgeTool?.();
            }
        }

        private resolveSnapPosition(lastll: LatLng, curll: LatLng, mapDrawer: MapDrawer): LatLng {
            const snapInfo = { isHelperLine: false };
            let snapped = HelperLinesTool.getSnapPosition(lastll, curll, mapDrawer, [mapDrawer.viewModel.layer.building], snapInfo);
            this.snappedOnHelperLine = !!snapped && snapInfo.isHelperLine;

            // If no building-boundary snap: also snap to vertices of existing ridge lines.
            // Covers ridge endpoints and T-junctions where ridges share a vertex.
            if (!snapped && this.target) {
                const proj = mapDrawer.map.getProjection();
                const scale = Math.pow(2, mapDrawer.map.getZoom());
                const curPt = proj?.fromLatLngToPoint(curll.ToGMLatLng());
                const tol = Helperline.clickTolerance;

                if (curPt) {
                    outer: for (const sp of this.target.separationPolylines) {
                        if (sp === this.separationPolyline) { 
                            continue; 
                        }
                        const path = sp.polyline?.getPath();
                        if (!path) { 
                            continue; 
                        }
                        for (let i = 0; i < path.getLength(); i++) {
                            const vtxPt = proj.fromLatLngToPoint(path.getAt(i));
                            const dx = (curPt.x - vtxPt.x) * scale;
                            const dy = (curPt.y - vtxPt.y) * scale;
                            if (Math.sqrt(dx * dx + dy * dy) < tol) {
                                snapped = LatLng.FromGMLatLng(path.getAt(i));
                                break outer;
                            }
                        }
                    }
                }
            }

            this.snapped = !!snapped;
            return snapped ?? curll;
        }

        onMousemove(ev: google.maps.MouseEvent, mapDrawer: MapDrawer) {
            if (!this.polyLine || !ev.latLng) return;

            const lastll = this.polyLine.getVisible() ? LatLng.FromGMLatLng(this.polyLine.getPath().getAt(0)) : null;
            const curll = LatLng.FromGMLatLng(ev.latLng);
            const ll = this.resolveSnapPosition(lastll, curll, mapDrawer);

            if (this.polyLine.getVisible())
                this.polyLine.getPath().setAt(1, ll.ToGMLatLng());

            this.snapMarker.setPosition(ll.ToGMLatLng());
            if (this.snapped !== this.snapMarker.getVisible())
                this.snapMarker.setVisible(this.snapped);
        }

        onClick(ev: google.maps.MouseEvent, mapDrawer: MapDrawer): void {
            // Handle touch placement on touchend for accurate snap detection.
            // Use _lastInteractionWasTouch instead of $.isTouchCapable() on hybrid devices.
            if ((mapDrawer as any)._lastInteractionWasTouch) return;
            this._doPlacement(ev, mapDrawer);
        }

        onMouseUp(ev: google.maps.MouseEvent, mapDrawer: MapDrawer): void {
            // Use touchend with pixel-distance tap detection for touch placement.
            // Ignore map.mouseup because map.drag can fire on minor finger movement.
            if ($.isTouchCapable()) return;
        }

        _doPlacement(ev: google.maps.MouseEvent, mapDrawer: MapDrawer): void {
            if (!this.target || !ev.latLng) return;

            if (this.target.separationPolylines.some(sp => sp.hovered))
                return;

            const curll = LatLng.FromGMLatLng(ev.latLng);
            const lastll = this.polyLine.getVisible() ? LatLng.FromGMLatLng(this.polyLine.getPath().getAt(0)) : null;
            const ll = this.resolveSnapPosition(lastll, curll, mapDrawer);

            if (!google.maps.geometry.poly.containsLocation(ll.ToGMLatLng(), this.target.poly as any)) {
                // Click is outside the current target building. At step 0 (before any ridge is started),
                // auto-switch to whichever building the user clicked on so they don't have to pre-select.
                if (this.step !== 0) {
                    return;
                }
                const buildingPolys = mapDrawer.viewModel.layer.building?.polygons ?? [];
                let newTarget: ShapeData = null;
                for (let i = 0; i < buildingPolys.length; i++) {
                    const bld = buildingPolys[i].userData as ShapeData;
                    if (bld !== this.target && google.maps.geometry.poly.containsLocation(ll.ToGMLatLng(), bld.poly as any)) {
                        newTarget = bld;
                        break;
                    }
                }
                if (!newTarget) {
                    return;
                }
                this.target = newTarget;
                this.target.useSimpleRidgeTool = true;
            }

            if (this.step === 0) {
                // First click must be on a snap point
                if (!this.snapped) return;

                this.target.suppressRegenerate = true;

                this.separationPolyline = new SeparationPolyline(mapDrawer, this.target, undefined, undefined, false);
                this.separationPolyline.polyline.getPath().push(ll.ToGMLatLng());

                this.polyLine.setVisible(true);
                this.polyLine.setPath([ll.ToGMLatLng(), ll.ToGMLatLng()]);

                this.step = 1;
            } else {
                // Intermediate points always accepted; snapping on a building vertex ends the line
                this.separationPolyline.polyline.getPath().push(ll.ToGMLatLng());
                this.polyLine.setPath([ll.ToGMLatLng(), ll.ToGMLatLng()]);

                this.target.update();

                if (this.snapped && !this.snappedOnHelperLine) {
                    this.target.suppressRegenerate = false;
                    this.target.update();

                    // Freeze the completed ridge so its transparent hover area no longer shows
                    // a pointer cursor or intercepts clicks while SimpleRidgeTool is active.
                    this.separationPolyline.frozen = true;

                    // Reset for next ridge — stay in tool without full re-select
                    this.step = 0;
                    this.separationPolyline = null;
                    this.polyLine.setVisible(false);

                    // Save current map state to localforage so SaveAsync() can find
                    // MapDrawerData for the SPT multi-roof export.
                    const mdData = mapDrawer.getDefaultMapDrawerData?.();
                    if (mdData) {
                        (window as any).lsApp?.storeSetItem?.('MapDrawerData', mdData);
                    }

                    refreshRoofOverlays();

                    // A ridge is now complete → refresh the ridge info box so the "Done" action appears.
                    (window as any).lsGoogleMaps?.notifyRidgeCompleted?.();
                }
            }
        }

        onKeyDown(key: any, mapDrawer: MapDrawer) {
            if (key === 'Escape')
                this.onDeselect(mapDrawer);
        }
    }


    const StepperEditorEvent = {
        Roof3DBuildingSelectionStarted: 'roof-3d-building-selection-started',
        Roof3DBuildingSelected: 'roof-3d-building-selected',
        Roof3DRoofSelectionAvailable: 'roof-3d-roof-selection-available',
        Roof3DRoofSelectionReset: 'roof-3d-roof-selection-reset',
        Roof3DRoofSelected: 'roof-3d-roof-selected',
        Roof3DRoofRestored: 'roof-3d-roof-restored',
        Roof3DRoofDeselected: 'roof-3d-roof-deselected'
    };

    function reportStepperEditorEvent(name: string) {
        (window as any).lsJsInvokable?.reportStepperEditorEvent?.({
            name,
            source: 'roof-3d'
        });
    }

    function hideStepperInfoBox() {
        (window as any).lsJsInvokable?.hideStepperInfoBox?.();
    }

    function refreshRoofOverlays() {
        (window as any).lsGoogleMaps?.refreshRoofOverlays?.();
    }

    function clearRoofOverlays() {
        (window as any).lsGoogleMaps?.clearRoofOverlays?.();
    }

    function reportRoof3DEditorEvent(name: string) {
        reportStepperEditorEvent(name);

        if (name === StepperEditorEvent.Roof3DBuildingSelectionStarted) {
            clearRoofOverlays();
            return;
        }

        refreshRoofOverlays();

        const roofStep = (window as any).lsJsInvokable?.getRefreshRoofStep?.();
        if (name === StepperEditorEvent.Roof3DRoofSelected || name === StepperEditorEvent.Roof3DRoofRestored) {
            roofStep?.invokeMethodAsync('CurrentRoofStepChanged', 313);
        } else if (name === StepperEditorEvent.Roof3DRoofDeselected) {
            roofStep?.invokeMethodAsync('CurrentRoofStepChanged', 1);
        }
    }

    function startRoofSelectionMode(mapDrawer: MapDrawer, restoreSelection = false, onSelected?: () => void, onDeselected?: () => void, completeBuildingSelection = false): (hideInfoBox?: boolean) => void {
        const roofLayer = mapDrawer.viewModel.layer.roof;
        if (!roofLayer || roofLayer.polygons.length === 0) {
            return () => {};
        }

        const roofPolygons = roofLayer.polygons;
        const origFillColor = roofLayer.shapeStyle?.fillColor;
        const origFillOpacity = roofLayer.shapeStyle?.fillOpacity;
        const selectedFillColor = '#bf4900';
        const selectedFillOpacity = 0.7;

        // Cloned button element appended directly to the map div.
        // Using CSS absolute positioning avoids Google Maps control-API centering issues
        // and Blazor re-render instability of the original DOM element.
        let infoButtonClone: HTMLElement | null = null;

        // Reset modal highlight globals; multi-roof path overwrites them once selectedRoofs is known.
        (window as any)._roofInfoData = null;
        (window as any)._highlightRoof3D = null;
        (window as any)._restoreRoofColors = null;

        function buildRoofInfoEntries(polys: IGoogleMapsPolygon[]) {
            const opts = mapDrawer.viewModel.valueAdjustOpts;
            const roofLabel = (window as any).translations?.["PageTitle"] ?? 'Dach';
            return polys.map((p, i) => {
                const data = (p as any).userData as ShapeData;
                const height = data?.height ?? 0;
                const slope  = data?.slope  ?? 0;
                return {
                    index: roofPolygons.indexOf(p),
                    name:  `${roofLabel} ${i + 1}`,
                    id:    (data as any)?.id ?? '',
                    heightDisplay: spt.Utils.GetFloatFromInputValue(height.toString(), { notImperial: true, from: 'mm', to: opts.to }) + ' m',
                    slopeDisplay:  (Math.round(slope * 100) / 100) + ' °',
                    isSloping: slope > 5
                };
            });
        }

        async function persistShapes() {
            const mapDrawerData = mapDrawer.getDefaultMapDrawerData();
            await Ajax.SaveMapDrawerData({ data: mapDrawerData });
            const client3dAjax = (window as any).LS?.Client3DEditor?.Ajax;
            if (client3dAjax) {
                const editorData = client3dAjax.extractMapDrawerData(mapDrawerData);
                if (editorData) {
                    await client3dAjax.SaveDataForEditor3D(editorData);
                }
            }
        }

        if (roofPolygons.length === 1) {
            const singleRoof = roofPolygons[0];
            const shapeData = (singleRoof as any).userData as ShapeData;
            const sm = shapeData?.southMarker;
            const origSmVisible = sm?.visible ?? false;
            shapeData.isActive = true;
            shapeData.showLengths = true;
            shapeData.update();
            if (sm) sm.visible = true;

            onSelected?.();
            reportRoof3DEditorEvent(StepperEditorEvent.Roof3DRoofSelected);
            let cleaned = false;

            // isActive change triggers updateStyle() via KO subscription which resets fill color.
            // Defer the orange to run after all pending KO reactions have settled.
            setTimeout(() => {
                if (!cleaned) {
                    singleRoof.setOptions({fillColor: selectedFillColor, fillOpacity: selectedFillOpacity});
                }
            }, 0);

            showHide3DInfoButton(true, buildRoofInfoEntries([singleRoof]));
            persistShapes();

            function deselectSingle() {
                doCleanup();
                onDeselected?.();
                (window as any).lsApp?.storeRemoveItem?.('MapDrawerData');
                (window as any).lsApp?.storeRemoveItem?.('Editor3DData');
                reportRoof3DEditorEvent(StepperEditorEvent.Roof3DRoofDeselected);
            }

            function doCleanup(hideInfoBox = true) {
                if (cleaned) return;
                cleaned = true;
                mapDrawer.removeItemFromSelection(shapeData);
                singleRoof.setOptions({ fillColor: origFillColor, fillOpacity: origFillOpacity });
                if (sm) sm.visible = origSmVisible;
                infoButtonClone?.remove();
                infoButtonClone = null;
                const gis3dTool = mapDrawer.viewModel?.toolIcons?.["Gis3DBuildingsTool"] as Gis3DBuildingsTool | undefined;
                gis3dTool?.cancelRestore();
                if (hideInfoBox) {
                    hideStepperInfoBox();
                    mapDrawer.deleteAll();
                }
            }

            (doCleanup as any).deselect = deselectSingle;
            (doCleanup as any).getActiveRoofId = () => (shapeData as any)?.id ?? null;
            return doCleanup;
        }
        
        const buildingPolys = (mapDrawer.viewModel.layer.building?.polygons ?? []).slice();
        if (buildingPolys.length === 0) return () => {};

        const origSouthMarkerVisible = new Map<IGoogleMapsPolygon, boolean>();
        roofPolygons.forEach(poly => {
            const sm = ((poly as any).userData as ShapeData)?.southMarker;
            if (sm) {
                origSouthMarkerVisible.set(poly, sm.visible);
                sm.visible = false;
            }
        });
        let hoveredRoof: IGoogleMapsPolygon = null;
        let selectedRoof: IGoogleMapsPolygon = null;
        const isMultiRoof = mapDrawer.viewModel.isMultiRoof ?? false;
        const selectedRoofs = new Set<IGoogleMapsPolygon>();
        let activeRoof: IGoogleMapsPolygon | null = null;

        function isRoofSelected(poly: IGoogleMapsPolygon) {
            return isMultiRoof ? selectedRoofs.has(poly) : poly === selectedRoof;
        }

        function setActiveRoof(poly: IGoogleMapsPolygon | null) {
            if (activeRoof === poly) return;
            const prev = activeRoof;
            activeRoof = poly;
            if (prev) prev.setOptions(roofStyle(prev));
            if (poly) poly.setOptions(roofStyle(poly));
            refreshRoofOverlays();
        }

        // Allow showModal3DRoofInfoDialog tab-switcher to highlight matching roof on map.
        (window as any)._highlightRoof3D = (index: number) => {
            roofPolygons.forEach(p => {
                if (!isRoofSelected(p)) return;
                p.setOptions({ fillColor: selectedFillColor, fillOpacity: roofPolygons.indexOf(p) === index ? 0.9 : 0.3 });
            });
        };
        (window as any)._restoreRoofColors = () => {
            roofPolygons.forEach(p => p.setOptions(roofStyle(p)));
        };

        function setRoofHovered(poly: IGoogleMapsPolygon, hovered: boolean) {
            const shapeData = (poly as any).userData as ShapeData;
            if (isRoofSelected(poly)) {
                poly.setOptions(roofStyle(poly));
                return;
            }

            shapeData.hovered = false;
            poly.setOptions(hovered ? {fillColor: '#FFEA00', fillOpacity: 0.65} : { fillColor: origFillColor, fillOpacity: origFillOpacity });
        }

        function roofStyle(poly: IGoogleMapsPolygon) {
            const isSelected = isRoofSelected(poly);
            const isHovered  = poly === hoveredRoof;
            if (isSelected) {
                const isActive = !isMultiRoof || poly === activeRoof;
                const fillOpacity = isActive
                    ? (isHovered ? 0.9 : 0.85)
                    : (isHovered ? 0.7 : 0.55);
                return { fillColor: selectedFillColor, fillOpacity };
            }
            if (isHovered) {
                return { fillColor: '#FFEA00', fillOpacity: 0.65 };
            }
            return { fillColor: origFillColor, fillOpacity: origFillOpacity };
        }

        function selectRoofShape(poly: IGoogleMapsPolygon) {
            const shapeData = (poly as any).userData as ShapeData;
            shapeData.isActive = true;
            const shapes = isMultiRoof
                ? [...selectedRoofs].map(p => (p as any).userData as ShapeData).filter(Boolean)
                : [shapeData];
            mapDrawer.selectShapes(shapes, true);
        }

        function setHoveredRoof(poly: IGoogleMapsPolygon | null) {
            if (poly === hoveredRoof) return;
            const prev = hoveredRoof;
            hoveredRoof = poly;
            if (prev) {
                setRoofHovered(prev, false);
            }
            if (poly) {
                setRoofHovered(poly, true);
            }
        }

        const preSelectedRoofs = restoreSelection
            ? roofPolygons.filter(p => ((p as any).userData as ShapeData)?.isActive)
            : [];
        const preSelected = preSelectedRoofs[0] ?? null;

        if (!preSelected) {
            if (completeBuildingSelection) {
                reportRoof3DEditorEvent(StepperEditorEvent.Roof3DBuildingSelected);
            } else if (restoreSelection) {
                reportRoof3DEditorEvent(StepperEditorEvent.Roof3DRoofSelectionAvailable);
            } else {
                reportRoof3DEditorEvent(StepperEditorEvent.Roof3DRoofSelectionReset);
            }
        } else {
            if (isMultiRoof) {
                preSelectedRoofs.forEach(p => selectedRoofs.add(p));
            } else {
                selectedRoof = preSelected;
            }
            onSelected?.();
            roofPolygons.forEach(p => { ((p as any).userData as ShapeData).isActive = isRoofSelected(p); });
            const activeRoofs = roofPolygons.filter(isRoofSelected);
            if (isMultiRoof) {
                // Keep the moved roof selected after restore.
                // Prevents the active pill from jumping.
                activeRoof = (_preferredActiveRoofId
                    ? activeRoofs.find(p => (((p as any).userData as ShapeData)?.id) === _preferredActiveRoofId)
                    : null) ?? activeRoofs[0] ?? null;
                _preferredActiveRoofId = null;
                activeRoofs.forEach(p => {
                    const sm = ((p as any).userData as ShapeData)?.southMarker;
                    if (sm) sm.visible = true;
                    const data = (p as any).userData as ShapeData;
                    if (data) { data.showLengths = true; data.update(); }
                });
                // Restore: do NOT call selectRoofShape here — mapDrawer.selectShapes() can trigger
                // save() → onSelect() → _tryRestoreFromSavedData() which replaces buildingPoly before
                // the click listener is wired, leaving a stale reference and breaking roof selection.
                // Defer fill color — KO reactions from isActive/showLengths changes reset it.
                setTimeout(() => {
                    activeRoofs.forEach(p => { if (isRoofSelected(p)) p.setOptions(roofStyle(p)); });
                }, 0);
                const lastRoof = activeRoofs[activeRoofs.length - 1];
                if (lastRoof) {
                    const lastData = (lastRoof as any).userData as ShapeData;
                    if (lastData) showHide3DInfoButton(true, buildRoofInfoEntries([...selectedRoofs]));
                }
            } else {
                // non-isMultiRoof: use select-roof-from-building design — selectRoofShape handles
                // mapDrawer selection state, styling is applied synchronously.
                const sm = ((preSelected as any).userData as ShapeData)?.southMarker;
                if (sm) sm.visible = true;
                const preSelectedData = (preSelected as any).userData as ShapeData;
                if (preSelectedData) {
                    preSelectedData.showLengths = true;
                    selectRoofShape(preSelected);
                    preSelectedData.update();
                    showHide3DInfoButton(true, buildRoofInfoEntries([preSelected]));
                }
            }
            reportRoof3DEditorEvent(StepperEditorEvent.Roof3DRoofRestored);
        }

        const listeners: google.maps.MapsEventListener[] = [];

        buildingPolys.forEach(bp => listeners.push(
            google.maps.event.addListener(bp, 'mousemove', (ev: google.maps.MouseEvent) => {
                if (!ev.latLng) return;
                const found = roofPolygons.find(p => google.maps.geometry.poly.containsLocation(ev.latLng, p as any)) || null;
                setHoveredRoof(found);
            })
        ));

        buildingPolys.forEach(bp => listeners.push(
            google.maps.event.addListener(bp, 'mouseout', () => setHoveredRoof(null))
        ));

        buildingPolys.forEach(bp => listeners.push(
            google.maps.event.addListener(bp, 'click', async (ev: google.maps.MouseEvent) => {
                if (!ev.latLng) return;
                const clicked = roofPolygons.find(p => google.maps.geometry.poly.containsLocation(ev.latLng, p as any));
                if (!clicked) return;
                if (isRoofSelected(clicked)) {
                    if (isMultiRoof) {
                        setActiveRoof(clicked);
                    } else {
                        await deselectRoof(clicked);
                    }
                } else {
                    await selectRoof(clicked);
                }
            })
        ));

        async function selectRoof(clicked: IGoogleMapsPolygon) {
            if (isMultiRoof) {
                selectedRoofs.add(clicked);
                activeRoof = clicked;
                if (selectedRoofs.size === 1) onSelected?.();

                reportRoof3DEditorEvent(StepperEditorEvent.Roof3DRoofSelected);
                roofPolygons.forEach(p => {
                    const sm = ((p as any).userData as ShapeData)?.southMarker;
                    if (sm) sm.visible = isRoofSelected(p);
                });
                const shapeData = (clicked as any).userData as ShapeData;
                shapeData.showLengths = true;
                shapeData.update();
                roofPolygons.forEach(p => { ((p as any).userData as ShapeData).isActive = isRoofSelected(p); });
                // Defer fill color — isActive/showLengths trigger KO → updateStyle() resets colors.
                // Do NOT call selectRoofShape: mapDrawer.selectShapes() can trigger save() → onSelect()
                // → _selectionToken++ → isSelectionActive fails on next building click.
                const selectedSnapshot = [...selectedRoofs];
                setTimeout(() => {
                    selectedSnapshot.forEach(p => { if (selectedRoofs.has(p)) p.setOptions(roofStyle(p)); });
                }, 0);
                showHide3DInfoButton(true, buildRoofInfoEntries([...selectedRoofs]));
            } else {
                // non-isMultiRoof: select-roof-from-building design — sync styling via selectRoofShape.
                const prev = selectedRoof;
                selectedRoof = clicked;
                onSelected?.();
                if (prev && prev !== clicked) {
                    const prevData = (prev as any).userData as ShapeData;
                    if (prevData) {
                        mapDrawer.removeItemFromSelection(prevData);
                        prevData.showLengths = null;
                        prevData.update();
                    }
                    setRoofHovered(prev, prev === hoveredRoof);
                }
                reportRoof3DEditorEvent(StepperEditorEvent.Roof3DRoofSelected);
                roofPolygons.forEach(p => {
                    const sm = ((p as any).userData as ShapeData)?.southMarker;
                    if (sm) sm.visible = p === clicked;
                });
                const shapeData = (clicked as any).userData as ShapeData;
                shapeData.showLengths = true;
                roofPolygons.forEach(p => { ((p as any).userData as ShapeData).isActive = p === clicked; });
                selectRoofShape(clicked);
                shapeData.update();
                showHide3DInfoButton(true, buildRoofInfoEntries([clicked]));
            }
            await persistShapes();
        }
        
        function showHide3DInfoButton(show: boolean, entries: Array<{index: number; name: string; id: string; heightDisplay: string; slopeDisplay: string; isSloping: boolean}> = []) {
            if (!show) {
                infoButtonClone?.classList.add('d-none');
                ($('#modal3DRoofInfo') as any).modal?.('hide');
                (window as any)._roofInfoData = null;
                return;
            }
            (window as any)._roofInfoData = entries;
        }
        
        async function deselectRoof(poly?: IGoogleMapsPolygon) {
            if (isMultiRoof) {
                const target = poly ?? null;
                if (target) {
                    selectedRoofs.delete(target);
                    if (activeRoof === target) {
                        activeRoof = [...selectedRoofs][selectedRoofs.size - 1] ?? null;
                    }
                    const targetData = (target as any).userData as ShapeData;
                    if (targetData) {
                        mapDrawer.removeItemFromSelection(targetData);
                        targetData.showLengths = null;
                        targetData.isActive = false;
                        targetData.update();
                    }
                    const sm = targetData?.southMarker;
                    if (sm) sm.visible = false;
                    setRoofHovered(target, target === hoveredRoof);
                }
                roofPolygons.forEach(p => { ((p as any).userData as ShapeData).isActive = selectedRoofs.has(p); });
                reportRoof3DEditorEvent(selectedRoofs.size === 0
                    ? StepperEditorEvent.Roof3DRoofDeselected
                    : StepperEditorEvent.Roof3DRoofSelected);
                if (selectedRoofs.size === 0) {
                    // Keep building polygons and listeners intact so the user can immediately
                    // re-select a roof without having to re-click the building outline.
                    showHide3DInfoButton(false);  // hides modal, clears _roofInfoData
                    (window as any)._highlightRoof3D = null;
                    (window as any)._restoreRoofColors = null;
                    infoButtonClone?.remove();
                    infoButtonClone = null;
                    setTimeout(() => {
                        if (target) target.setOptions(roofStyle(target));
                    }, 0);
                    onDeselected?.();
                    (window as any).lsApp?.storeRemoveItem?.('MapDrawerData');
                    (window as any).lsApp?.storeRemoveItem?.('Editor3DData');
                } else {
                    const deselectedRef = target;
                    setTimeout(() => {
                        if (deselectedRef && !selectedRoofs.has(deselectedRef)) deselectedRef.setOptions(roofStyle(deselectedRef));
                        [...selectedRoofs].forEach(p => p.setOptions(roofStyle(p)));
                    }, 0);
                    showHide3DInfoButton(true, buildRoofInfoEntries([...selectedRoofs]));
                    await persistShapes();
                }
                return;
            }
            const prev = selectedRoof;
            selectedRoof = null;
            roofPolygons.forEach(p => { ((p as any).userData as ShapeData).isActive = false; });
            reportRoof3DEditorEvent(StepperEditorEvent.Roof3DRoofDeselected);
            if (prev) {
                const prevData = (prev as any).userData as ShapeData;
                if (prevData) {
                    mapDrawer.removeItemFromSelection(prevData);
                    prevData.showLengths = null;
                    prevData.update();
                }
                setRoofHovered(prev, prev === hoveredRoof);
            }
            showHide3DInfoButton(false);
            onDeselected?.();
            (window as any).lsApp?.storeRemoveItem?.('MapDrawerData');
            (window as any).lsApp?.storeRemoveItem?.('Editor3DData');
        }

        function cleanup(hideInfoBox = true) {
            listeners.forEach(l => google.maps.event.removeListener(l));
            listeners.length = 0;
            roofPolygons.forEach(poly => {
                poly.setOptions({ fillColor: origFillColor, fillOpacity: origFillOpacity });
                const sm = ((poly as any).userData as ShapeData)?.southMarker;
                if (sm) sm.visible = origSouthMarkerVisible.get(poly) ?? false;
            });
            infoButtonClone?.remove();
            infoButtonClone = null;
            ($('#modal3DRoofInfo') as any).modal?.('hide');
            (window as any)._roofInfoData     = null;
            (window as any)._highlightRoof3D   = null;
            (window as any)._restoreRoofColors = null;
            if (hideInfoBox) {
                hideStepperInfoBox();
            }
        }

        (cleanup as any).deselect = () => {
            if (isMultiRoof) {
                [...selectedRoofs].forEach(p => { void deselectRoof(p); });
            } else {
                void deselectRoof();
            }
        };
        (cleanup as any).deselectById = (id: string) => {
            if (isMultiRoof) {
                const poly = roofPolygons.find(p => ((p as any).userData as any)?.id === id);
                if (poly && selectedRoofs.has(poly)) void deselectRoof(poly);
            } else {
                void deselectRoof();
            }
        };
        (cleanup as any).getActiveRoofId = () => {
            const poly = isMultiRoof ? activeRoof : selectedRoof;
            return poly ? ((poly as any).userData as ShapeData)?.id ?? null : null;
        };
        return cleanup;
    }

    export class Gis3DBuildingsTool extends BaseToolIcon {
        private _cleanupRoofSelection: ((hideInfoBox?: boolean) => void) | null = null;
        private _selectionToken = 0;
        private _restoreToken = 0;
        private _hasSelectedRoof = false;
        private _isSelectingBuilding = false;
        private _keepInfoBoxOnNextDeselect = false;

        get hasSelectedRoof() { return this._hasSelectedRoof; }

        cleanupRoofSelection() {
            this._cleanupRoofSelection?.();
            this._cleanupRoofSelection = null;
        }

        deselectSelectedRoof() {
            (this._cleanupRoofSelection as any)?.deselect?.();
        }

        deselectRoofById(id: string) {
            (this._cleanupRoofSelection as any)?.deselectById?.(id);
        }

        getActiveRoofId(): string | null {
            return (this._cleanupRoofSelection as any)?.getActiveRoofId?.() ?? null;
        }

        keepInfoBoxOnNextDeselect() {
            this._keepInfoBoxOnNextDeselect = true;
        }

        private getClickedBuildingPosition(newMapShapes: SolarProTool.MapShape[]): { lat: number, lng: number } | null {
            const building = newMapShapes.filter(s => s.TypeName === (window as any).BuildingTypeName)[0] ?? newMapShapes[0];
            const points = building?.borders?.[0]?.points;
            if (!points || !points.length) {
                return null;
            }

            let latSum = 0, lngSum = 0;
            points.forEach(p => { latSum += p.latitude; lngSum += p.longitude; });
            return { lat: latSum / points.length, lng: lngSum / points.length };
        }

        private _startBuildings(mapDrawer: MapDrawer, selectionToken: number) {
            if (mapDrawer.viewModel.isMultiRoof) {
                mapDrawer.gis3DBuildings.start(
                    mapDrawer,
                    newMapShapes => {
                        if (!this.isSelectionActive(mapDrawer, selectionToken)) return;
                        // If every building in the incoming shapes is already imported,
                        // this is a re-click on an existing building (e.g. user clicking a
                        // roof area). Skip the reset so the buildingPoly click handler can fire.
                        const mapShapes = mapDrawer.exportShapes();
                        const existingBuildingIds = new Set(
                            mapShapes.filter(s => s.TypeName === (window as any).BuildingTypeName)
                                     .map(s => s.IdString).filter(Boolean)
                        );
                        const incomingBuildingIds = newMapShapes
                            .filter(s => s.TypeName === (window as any).BuildingTypeName)
                            .map(s => s.IdString).filter(Boolean);
                        if (incomingBuildingIds.length > 0 && incomingBuildingIds.every(id => existingBuildingIds.has(id))) {
                            return;
                        }

                        const applyClickedBuilding = () => {
                            if (!this.isSelectionActive(mapDrawer, selectionToken)) {
                                return;
                            }
                            // Re-export: when deferred via the far-from-project dialog this runs later.
                            const currentShapes = mapDrawer.exportShapes();
                            this._restoreToken++;
                            const hadSelectedRoof = this._hasSelectedRoof;
                            const completeBuildingSelection = this._isSelectingBuilding;
                            this._isSelectingBuilding = false;
                            const newRoofCount = newMapShapes.filter(s => s.TypeName === (window as any).RoofTypeName).length;
                            const selectedRoofIds = new Set(
                                currentShapes
                                    .filter(s => s.TypeName === (window as any).RoofTypeName && s.IsActive)
                                    .map(s => s.IdString)
                                    .filter(Boolean)
                            );
                            // For a single-roof building, auto-add its roof to the existing selection.
                            const newRoofIds = newRoofCount === 1
                                ? new Set(newMapShapes.filter(s => s.TypeName === (window as any).RoofTypeName).map(s => s.IdString).filter(Boolean))
                                : null;
                            const mergedShapes = mergeMapShapes(currentShapes, newMapShapes);
                            mergedShapes.forEach(s => {
                                if (s.TypeName === (window as any).RoofTypeName) {
                                    s.IsActive = selectedRoofIds.has(s.IdString) || (newRoofIds?.has(s.IdString) ?? false);
                                }
                            });
                            mapDrawer.viewModel.isNewGis3DBuilding = true;
                            mapDrawer.deleteAll();
                            mapDrawer.importShapes(mergedShapes);
                            this._cleanupRoofSelection?.(false);
                            this._cleanupRoofSelection = startRoofSelectionMode(mapDrawer, hadSelectedRoof, () => { this._hasSelectedRoof = true; }, () => { this._hasSelectedRoof = false; }, completeBuildingSelection);
                        };

                        const clickedPosition = this.getClickedBuildingPosition(newMapShapes);

                        // buildings too far apart cannot be merged and would replace the current selection
                        // replacement requires confirmation before the existing selection is removed
                        if (existingBuildingIds.size > 0 && wouldReplaceMapShapes(mapShapes, newMapShapes)
                            && clickedPosition
                            && lsGoogleMaps.deferRoofReplacement(clickedPosition.lat, clickedPosition.lng, applyClickedBuilding)) {
                            return;
                        }

                        applyClickedBuilding();

                        // warn when the first selection ist far from the project address
                        // the warning can be dismissed
                        if (existingBuildingIds.size === 0 && clickedPosition) {
                            lsGoogleMaps.reportRoofPlacedAt(clickedPosition.lat, clickedPosition.lng,
                                () => { void lsGoogleMaps.reset3DRoofSelection(); });
                        }
                    }
                );
            } else {
                mapDrawer.gis3DBuildings.start(
                    mapDrawer,
                    newMapShapes => {
                        if (!this.isSelectionActive(mapDrawer, selectionToken)) return;
                        const completeBuildingSelection = this._isSelectingBuilding;
                        this._isSelectingBuilding = false;
                        this._cleanupRoofSelection?.(false);
                        this._cleanupRoofSelection = null;
                        mapDrawer.viewModel.isNewGis3DBuilding = true;
                        mapDrawer.deleteAll();
                        mapDrawer.importShapes(newMapShapes);
                        this._cleanupRoofSelection = startRoofSelectionMode(mapDrawer, false, () => { this._hasSelectedRoof = true; }, () => { this._hasSelectedRoof = false; }, completeBuildingSelection);
                        const clickedPosition = this.getClickedBuildingPosition(newMapShapes);
                        if (clickedPosition) {
                            lsGoogleMaps.reportRoofPlacedAt(clickedPosition.lat, clickedPosition.lng);
                        }
                    },
                    () => {
                        if (!this.isSelectionActive(mapDrawer, selectionToken)) return;
                        this._restoreToken++;
                        mapDrawer.deleteAll();
                        this._cleanupRoofSelection?.(false);
                        this._cleanupRoofSelection = null;
                        this._hasSelectedRoof = false;
                        this._isSelectingBuilding = true;
                        reportRoof3DEditorEvent(StepperEditorEvent.Roof3DBuildingSelectionStarted);
                    }
                );
            }
        }

        private isSelectionActive(mapDrawer: MapDrawer, selectionToken: number) {
            return this._selectionToken === selectionToken && mapDrawer.show3dBuildings;
        }

        cancelRestore() {
            this._restoreToken++;
        }

        cancelPendingSelection() {
            this._selectionToken++;
            this._restoreToken++;
            this._isSelectingBuilding = false;
        }

        restartBuildingSelection() {
            this._isSelectingBuilding = true;
            reportRoof3DEditorEvent(StepperEditorEvent.Roof3DBuildingSelectionStarted);
        }

        restoreFromShapes(mapDrawer: MapDrawer, shapes: SolarProTool.MapShape[]) {
            this._restoreToken++;
            this._isSelectingBuilding = false;
            mapDrawer.viewModel.isNewGis3DBuilding = true;
            mapDrawer.importShapes(shapes);
            this._cleanupRoofSelection?.(false);
            this._cleanupRoofSelection = startRoofSelectionMode(mapDrawer, true,
                () => { this._hasSelectedRoof = true; },
                () => { this._hasSelectedRoof = false; }
            );
        }

        onSelect(mapDrawer: MapDrawer, prevTool?: BaseToolIcon) {
            const isEntering3DTool = prevTool?.name !== this.name;
            const selectionToken = ++this._selectionToken;
            this._hasSelectedRoof = false;
            this._isSelectingBuilding = isEntering3DTool;
            if (isEntering3DTool) {
                reportRoof3DEditorEvent(StepperEditorEvent.Roof3DBuildingSelectionStarted);
            }
            const token = ++this._restoreToken;
            this._startBuildings(mapDrawer, selectionToken);
            this._tryRestoreFromSavedData(mapDrawer, token);
        }

        private async _tryRestoreFromSavedData(mapDrawer: MapDrawer, token: number) {
            const stored = await (window as any).lsApp?.storeGetItem?.('MapDrawerData');
            if (this._restoreToken !== token || !mapDrawer.show3dBuildings) return;
            const shapes: SolarProTool.MapShape[] = stored?.Shapes ?? [];
            const roofCount = shapes.filter((s: any) => s.TypeName === (window as any).RoofTypeName).length;
            if (roofCount === 0) return;

            this._isSelectingBuilding = false;
            mapDrawer.viewModel.isNewGis3DBuilding = true;
            mapDrawer.importShapes(shapes);
            this._cleanupRoofSelection?.(false);
            this._cleanupRoofSelection = startRoofSelectionMode(mapDrawer, true,
                () => { this._hasSelectedRoof = true; },
                () => { this._hasSelectedRoof = false; }
            );
        }

        onDeselect(mapDrawer: MapDrawer) {
            const hideInfoBox = !this._keepInfoBoxOnNextDeselect;
            this._keepInfoBoxOnNextDeselect = false;
            this._selectionToken++;
            this._restoreToken++;
            this._isSelectingBuilding = false;
            this._cleanupRoofSelection?.(hideInfoBox);
            this._cleanupRoofSelection = null;
            mapDrawer.gis3DBuildings.stop();
            if (hideInfoBox) {
                hideStepperInfoBox();
            }
        }
    }

    // Moves the building that owns the dragged roof.
    // Ownership is resolved spatially, then the new position is persisted.
    let _buildingMoveActive = false;
    let _buildingMoveSaving = false;
    // Roof to re-activate after the post-move re-import
    let _preferredActiveRoofId: string | null = null;

    export function beginBuildingMoveDrag(mapDrawer: MapDrawer, roofId: string, startEv: PointerEvent): boolean {
        if (!mapDrawer || _buildingMoveActive || _buildingMoveSaving) {
            return false;
        }

        const startGmLatLng = mapDrawer.GetLatLngFromMouseEvent(startEv as any);
        if (!startGmLatLng) {
            return false;
        }

        const roofData = (mapDrawer.viewModel.layer.roof?.polygons ?? [])
            .map(p => (p as any).userData as ShapeData)
            .find(d => d && !d._isDisposed && d.id === roofId);
        if (!roofData) {
            return false;
        }

        const buildings = getMoveBuildings(mapDrawer);
        const building = (roofData.parent && !roofData.parent._isDisposed && roofData.parent.typeName === window.BuildingTypeName)
            ? roofData.parent
            : findMoveOwner(roofData, buildings);
        if (!building) {
            return false;
        }

        const group = collectBuildingMoveGroup(building, buildings, mapDrawer);

        let lastLatLng = LatLng.FromGMLatLng(startGmLatLng);
        let moved = false;
        _buildingMoveActive = true;

        const onPointerMove = (ev: PointerEvent) => {
            // Keep the drag away from Google Maps: no hover/pan side effects from
            // pointer moves whose pointerdown was swallowed on the pill handle.
            ev.preventDefault();
            ev.stopPropagation();

            const gmLatLng = mapDrawer.GetLatLngFromMouseEvent(ev as any);
            if (!gmLatLng) {
                return;
            }

            const cur = LatLng.FromGMLatLng(gmLatLng);
            const delta = cur.sub(lastLatLng);

            if (delta.Latitude === 0 && delta.Longitude === 0) {
                return;
            }

            moveBuildingGroupBy(group, delta);
            lastLatLng = cur;
            moved = true;
        };

        const onPointerUp = (ev: PointerEvent) => {
            ev.stopPropagation();
            document.removeEventListener('pointermove', onPointerMove, true);
            document.removeEventListener('pointerup', onPointerUp, true);
            document.removeEventListener('pointercancel', onPointerUp, true);
            _buildingMoveActive = false;

            if (moved) {
                // Keep the dragged roof the active one across the re-import.
                _preferredActiveRoofId = roofId;
                // Block new drags until the save has finished.
                _buildingMoveSaving = true;
                const result = (window as any).lsGoogleMaps?.finishBuildingMove?.(roofId);
                Promise.resolve(result).then(
                    () => { _buildingMoveSaving = false; },
                    () => { _buildingMoveSaving = false; }
                );
            }
        };

        document.addEventListener('pointermove', onPointerMove, true);
        document.addEventListener('pointerup', onPointerUp, true);
        document.addEventListener('pointercancel', onPointerUp, true);
        return true;
    }

    function getMoveBuildings(mapDrawer: MapDrawer): ShapeData[] {
        return (mapDrawer.viewModel.layer.building?.polygons ?? [])
            .map(p => (p as any).userData as ShapeData)
            .filter(d => d && !d._isDisposed);
    }

    function findMoveOwner(roof: ShapeData, buildings: ShapeData[]): ShapeData | null {
        if (buildings.length <= 1) {
            return buildings[0] ?? null;
        }

        const center = roof.bounds.Center.ToGMLatLng();

        const containing = buildings.find(b =>
            b.poly && google.maps.geometry.poly.containsLocation(center, b.poly as any));
        if (containing) {
            return containing;
        }

        let nearest: ShapeData = null;
        let nearestDist = Number.MAX_VALUE;
        buildings.forEach(b => {
            if (!b.poly) {
                return;
            }
            const dist = roof.bounds.Center.DistanceTo(b.bounds.Center);
            if (dist < nearestDist) {
                nearestDist = dist;
                nearest = b;
            }
        });
        return nearest;
    }

    // Building plus every roof face belonging to it. Ownership is resolved like
    // importShapes does for manual buildings: centroid containment, then nearest.
    function collectBuildingMoveGroup(building: ShapeData, buildings: ShapeData[], mapDrawer: MapDrawer): ShapeData[] {
        const group: ShapeData[] = [building];

        (mapDrawer.viewModel.layer.roof?.polygons ?? [])
            .map(p => (p as any).userData as ShapeData)
            .filter(d => d && !d._isDisposed)
            .forEach(roof => {
                const owner = (roof.parent && !roof.parent._isDisposed) ? roof.parent : findMoveOwner(roof, buildings);
                if (owner === building && group.indexOf(roof) < 0) {
                    group.push(roof);
                }
            });

        // Manual buildings keep their children relation; include any child that
        // is not part of the roof layer sweep above.
        (building.children ?? []).forEach(child => {
            if (child && !child._isDisposed && group.indexOf(child) < 0) {
                group.push(child);
            }
        });

        return group;
    }

    function moveBuildingGroupBy(group: ShapeData[], delta: LatLng) {
        group.forEach(shape => {
            if (shape._isDisposed) {
                return;
            }

            shape.moveByLatLng(delta);

            // Deactivated/deleted faces are matched by centroid distance on
            // regenerate, so their stored positions must move along too.
            const shift = (list: LatLng[]) => (list ?? []).map(c => new LatLng(c.Latitude + delta.Latitude, c.Longitude + delta.Longitude));
            shape.inactiveFaceCentroids = shift(shape.inactiveFaceCentroids);
            shape.deletedFaceCentroids = shift(shape.deletedFaceCentroids);
        });
    }

    export class RidgeTool extends BaseToolIcon {
        constructor(mapDrawer: MapDrawer, name: string, title: string) {
            super(mapDrawer, name, title);
            this.Cursor = 'crosshair';
            this.isCutting = false;
        }

        iconX = 16;
        iconY = 1;

        subMenu = [
            new BaseSubToolIcon('Draw', 'Draw', 1, 7)
        ];

        target: ShapeData = null;
        separationPolyline: SeparationPolyline = null;
        private polyLines: google.maps.Polyline[] = null;
        private snapMarker: google.maps.Marker = null;
        isCutting: boolean = false;
        step: number = 0;

        onSelect(mapDrawer: MapDrawer, prevTool: BaseToolIcon, subMenu: string) {
            var viewmodel = mapDrawer.viewModel,
                buildingLayer = viewmodel.layer.building,
                buildingPolys = buildingLayer ? buildingLayer.polygons : null;

            this.curSubmenu = subMenu = subMenu || 'Draw';

            if (!buildingLayer || !buildingPolys.length) {
                mapDrawer.selectTool("SelectTool");
                return;
            }

            mapDrawer.clearSelection();

            buildingPolys.forEach(poly => {
                (poly.userData as ShapeData).separationPolylines.forEach(sp => {
                    sp.frozen = true;
                });
            });

            //var target = this.target = viewmodel.selection[0] as ShapeData;

            this.target = buildingPolys[0].userData as ShapeData;

            var c = LatLng.FromGMLatLng(mapDrawer.map.getCenter());

            var shapeStyle = $.extend({}, SeparationPolyline.shapeStyle);
            if (this.isCutting)
                shapeStyle.strokeColor = '#bc0000';

            this.polyLines = [new google.maps.Polyline($.extend({
                map: mapDrawer.map,
                draggable: false,
                editable: false,
                clickable: false,
                visible: false,
                zIndex: 0,
                path: [c.ToGMLatLng(), c.ToGMLatLng()]
            }, shapeStyle) as google.maps.PolylineOptions)];

            this.step = 0;

            this.snapMarker = new google.maps.Marker({
                map: mapDrawer.map,
                clickable: false,
                draggable: false,
                visible: false,
                position: c.ToGMLatLng(),
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: shapeStyle.strokeWeight * 3,
                    fillColor: shapeStyle.strokeColor,
                    fillOpacity: shapeStyle.strokeOpacity,
                    strokeOpacity: 0
                },
                zIndex: 0
            });

            mapDrawer.setDrawingMode(true);

            mapDrawer.map.setOptions({ draggableCursor: this.Cursor });
        }

        onDeselect(mapDrawer: MapDrawer) {
            var viewmodel = mapDrawer.viewModel,
                layer = viewmodel.layer.building,
                polys = layer ? layer.polygons : null;

            viewmodel.currentSubViewModel = null;
            
            if(polys != null)
            {
                polys.forEach(poly => {
                    (poly.userData as ShapeData).separationPolylines.forEach(sp => {
                        sp.frozen = false;
                    });
                });
            }

            if (this.snapMarker) {
                this.snapMarker.setMap(null);
                this.snapMarker = null;
            }
            if (this.polyLines && this.polyLines.length) {
                this.polyLines.forEach(polyLine => {
                    polyLine.setMap(null);
                });
                this.polyLines = null;
            }

            if (this.separationPolyline &&
                this.separationPolyline.isCutting &&
                this.separationPolyline.latLngs &&
                this.separationPolyline.latLngs.length <= 1) {
                this.separationPolyline.remove();
            }

            this.target = null;
            this.separationPolyline = null;

            mapDrawer.setDrawingMode(false);

            mapDrawer.map.setOptions({ draggableCursor: null });
        }

        onMousemove(ev: google.maps.MouseEvent, mapDrawer: MapDrawer) {

            let snapMarker = this.snapMarker,
                polyLine = this.polyLines[0],
                ll: LatLng;

            let lastll = polyLine.getVisible() ? LatLng.FromGMLatLng(polyLine.getPath().getAt(0)) : null;

            let curll = LatLng.FromGMLatLng(ev.latLng);

            ll = HelperLinesTool.getSnapPosition(lastll, curll, mapDrawer, [mapDrawer.viewModel.layer.building]);

            if (!ll) {
                ll = curll;
                this.snapped = false;
            } else
                this.snapped = true;

            if (polyLine.getVisible()) {
                let polyLinePath = polyLine.getPath();
                polyLinePath.setAt(1, ll.ToGMLatLng());
            }

            snapMarker.setPosition(ll.ToGMLatLng());


            if (this.snapped !== snapMarker.getVisible())
                snapMarker.setVisible(this.snapped);

        }

        onClick(ev: google.maps.MouseEvent, mapDrawer: MapDrawer): void {
            if (this.target) {

                let curll = LatLng.FromGMLatLng(ev.latLng),
                    polyLine = this.polyLines[0];

                if (this.target.separationPolylines.some(sp => sp.hovered))
                    return;

                let separationPolyline = this.separationPolyline;
                let lastll = polyLine.getVisible() ? LatLng.FromGMLatLng(polyLine.getPath().getAt(0)) : null;

                let ll = HelperLinesTool.getSnapPosition(lastll, curll, mapDrawer, [mapDrawer.viewModel.layer.building]);
                if (!ll) {
                    ll = curll;
                    this.snapped = false;
                } else
                    this.snapped = true;

                if (this.snapped || google.maps.geometry.poly.containsLocation(ll.ToGMLatLng(), this.target.poly as any)) {

                    if (!separationPolyline)
                        separationPolyline = this.separationPolyline = new SeparationPolyline(mapDrawer, this.target, undefined, undefined, !!this.isCutting);

                    separationPolyline.polyline.getPath().push(ll.ToGMLatLng());

                    if (!polyLine.getVisible())
                        polyLine.setVisible(true);

                    polyLine.setPath([ll.ToGMLatLng(), ll.ToGMLatLng()]);

                    this.target.update();

                    if ((window as any).mapDrawerWizard && separationPolyline.points.length === 2) {
                        (window as any).mapDrawerWizard.setStepSouthMarker(true);
                    }
                }
            }

        }

        onKeyDown(key: string, mapDrawer: MapDrawer) {
            if (key === 'd' && this.target) //d
                this.target.regenerate(true);
            else if (key === 'Escape') // ESC
            {
                if ((window as any).mapDrawerWizard && this.separationPolyline?.points.length === 2) {
                    (window as any).mapDrawerWizard.setStepSouthMarker(true);
                    (window as any).mapDrawerWizard.show();
                }
                this.onDeselect(mapDrawer);
            }
        }
    }

    export class CutTool extends RidgeTool {

        iconX = 15;
        iconY = 6;

        constructor(mapDrawer: MapDrawer, name: string, title: string) {
            super(mapDrawer, name, title);
            this.isCutting = true;
        }
    }
  
}
